import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import toast, { useToasterStore } from "react-hot-toast";
import {
  FaArrowRight,
  FaClipboard,
  FaCloudDownloadAlt,
  FaCopy,
  FaForward,
  FaSave,
  FaShare,
  FaTrash,
  FaWindowClose,
  FaPaste,
  FaShareAlt,
} from "react-icons/fa";
import ReactModal from "react-modal";
import {
  ActivityIndicator,
  Clipboard,
  FlatList,
  StyleSheet,
  Switch,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { isIOS } from "react-device-detect";
import screenfull from "screenfull";
import Logo from "../assets/Logo";
import RotateImg from "../assets/rotate.gif";
import PositionLayedMap from "../components/Football/PositionLayedMap";
import {
  AddToActionLog,
  ClearActionLog,
  ClearCurrentAction,
  ClearFullAnalyseString,
  FetchMatchStringFromServer,
  PushMatchStringToServer,
  SetCurrentAction,
  SetFullAnalyseString,
  SetVideoControl,
} from "../redux/actions/controlAction";
import { freeKickAnalyzer, passAnalyzer } from "../utils/validations";
import { MAIN_API, SSENSE_URL } from "../config/stepoutAPI";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { updateEventLog } from "../config/mainRequest";
import { Box, IconButton, Stack } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import SubtitionModal from "../components/SubtitutionModal";
import { useChannel } from "ably/react";
import useVideoDuration from "../hooks/useVideoDuration";
import BallTracking from "./BallTracking";

const classifyPassType = (start, end, isFromPSKey = false) => {
  const x1 = (start - 1) % 10;
  const y1 = Math.floor((start - 1) / 10);
  const x2 = (end - 1) % 10;
  const y2 = Math.floor((end - 1) / 10);
  const dx = Math.abs(x2 - x1);
  const dy = Math.abs(y2 - y1);

  const deepflankzone = [1, 2, 3, 11, 12, 13, 61, 62, 63, 71, 72, 73];
  const pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];

  if (!isFromPSKey && deepflankzone.includes(start) && pboxzone.includes(end)) {
    return { type: "C", notation: "1" };
  }

  if ((dx <= 1 && dy <= 2) || (dx <= 2 && dy <= 1)) {
    return { type: "SP", notation: "1" };
  }
  return { type: "LP", notation: "1" };
};

const usePersistentState = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    const saved = localStorage.getItem(key);
    return saved !== null ? saved : defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(key, value);
  }, [key, value]);

  return [value, setValue];
};

const InputBoardNewEvents = (props) => {
  const { matchId } = useParams();

  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [press, set] = useState([]);
  const [isLandscape, setIsLandscape] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [matchDetails, setMatchDetails] = useState(null);
  const [teamADetails, setTeamADetails] = useState(null);
  const [teamBDetails, setTeamBDetails] = useState(null);
  const [teamAPlayers, setTeamAPlayers] = useState(null);
  const [teamBPlayers, setTeamBPlayers] = useState(null);
  const [teamASubsPlayers, setTeamASubsPlayers] = useState(null);
  const [teamBSubsPlayers, setTeamBSubsPlayers] = useState(null);
  const [videoTimeFromServerOld, setvideoTimeFromServer] = useState(null);
  const [matchVideoData, setMatchVideoData] = useState(null);

  const [startPos, setStartPos] = useState("X");
  const [endPos, setEndPos] = useState("X");
  const [halfTag, setHalfTag] = useState("FHN");
  const [playerSelect, setPlayerSelect] = useState("X-X");
  const [actionAttrib, setActionAttrib] = useState("X");
  const [notate, setNotate] = useState("X");
  const [specialAction, setSpecialAction] = useState("X");
  const [actFoot, setActFoot] = useState("X");
  // const [prevAction, setPrevAction] = useState("X-X-X-X-X-X-X-X-X-X");
  // const [currAction, setCurrAction] = useState("X-X-X-X-X-X-X-X-X-X");
  // const [secondAction, setSecondAction] = useState("X-X-X-X-X-X-X-X-X-X");
  const [prevAction, setPrevAction] = useState("X-X-X-X-X-X-X-X-X-X-X-X");
  const [currAction, setCurrAction] = useState("X-X-X-X-X-X-X-X-X-X-X-X");
  const [secondAction, setSecondAction] = useState("X-X-X-X-X-X-X-X-X-X-X-X");
  const [secActFlag, setSecondActFlag] = useState(false);
  const [fullstringanalyse, setFullstringanalyse] = useState("");
  const [secondHalf, setSecondHalf] = useState(false);
  const [elapsedTime, setElapseTime] = useState(null);
  const [closeRequested, setCloseRequested] = useState(false);
  const [showDialog, setShowDialog] = useState(null);

  const [errorStrings, setErrorStrings] = useState(null);
  const [originalForFormating, setOriginalForFormating] = useState(null);
  const [stringLastTime, setStringLastTime] = useState("");
  const [stringStartTime, setStringStartTime] = useState("");
  const [openStringFixer, setOpenStringFixer] = useState(false);
  const [ErrorStrOnFocus, setErrorStrOnFocus] = useState(null);

  const [mergingLoading, setMergingLoading] = useState(false);
  const [formatProgress, setFormatProgress] = useState(false);
  const [teamAGK, setTeamAGK] = usePersistentState(
    `teamAGK-${matchId}-${props.analystId}`,
    "",
  );
  const [teamBGK, setTeamBGK] = usePersistentState(
    `teamABGK-${matchId}-${props.analystId}`,
    "",
  );

  const [proMode, setProMode] = useState(true);
  const [showSideChangeAlert, setShowSideChangeAlert] = useState(false);
  const [showSideChangeAlert2, setShowSideChangeAlert2] = useState(false);
  const [showBoxAlert, setShowBoxAlert] = useState(false);
  const [eventLogStatus, setEventLogStatus] = useState("");
  const [analysisStatus, setAnalysisStatus] = useState(null);
  const [showSubstitutionModal, setShowSubstitutionModal] = useState(false);
  const [fetchingTime, setFetchingTime] = useState(false);
  // states for Z axis modal;
  const [openZModal, setOpenZModal] = useState(false);
  const [showZButton, setShowZButton] = useState(false);
  const [selectedCells, setSelectedCells] = useState({
    ball: null,
    keeper: null,
  });

  const originalListRef = useRef();
  const history = useHistory();

  const matchVideo = matchDetails?.youtube_videos?.find((item) => {
    return item?.matches?.[0].toString() === matchId.toString();
  });

  const videoDuration = useVideoDuration(matchVideo?.url);

  const videoTimeFromServer = useRef(9000);

  const { channel } = useChannel(
    "analyst_portal_" + props.analystId,
    // "match_analysis_event",
    (message) => {
      if ((message.name = `time_update_${matchId}`)) {
        // console.log(message?.data);
        const time = message?.data?.timeMs;
        videoTimeFromServer.current = time || 0;
      }
    },
  );

  // const { props.analystName } = useSelector((state) => ({
  //   props.analystName: state.auth.props.analystName,
  // }));

  useEffect(() => {
    if (ErrorStrOnFocus && originalForFormating) {
      originalListRef.current.scrollToIndex({
        animated: true,
        index: ErrorStrOnFocus.index,
      });
    }
  }, [ErrorStrOnFocus, originalForFormating]);

  useEffect(() => {
    if (width && height) {
      width > height ? setIsLandscape(true) : setIsLandscape(false);
    }
  }, [height, width]);

  // useEffect(() => {
  //   fetchvideoTimeFromServer?.current();
  // }, [isFullScreen]);

  // const fetchvideoTimeFromServer = useCallback(async () => {
  //   // setFetchingTime(true);
  //   const fd = new FormData();
  //   fd.append("match_id", matchId);
  //   fd.append("analyst_id", props.analystId);
  //   const response = await axios.post(
  //     `${SSENSE_URL}get_match_video_data/v2/`,
  //     fd
  //   );

  //   const data = await response.data;
  //   // setFetchingTime(false);
  //   if (data) {
  //     const videoTimeStamp = data && data.video_timestamp;
  //     setvideoTimeFromServer(videoTimeStamp);
  //     setMatchVideoData(data);
  //     // console.log(data?.last_timestamp);
  //     return data.video_timestamp;
  //   }
  // }, [matchId, props.analystId]);

  // useEffect(() => {
  //   fetchvideoTimeFromServer();
  // }, []);

  // analysis_event_status: "pause"
  // current_analysis_time: "2024-10-26T14:02:34.744000"
  // total_video_duration_in_sec: 5406

  const getAnalysisStatus = useCallback(async () => {
    try {
      const res = await axios.post(
        `${MAIN_API}get_matchwise_analysis_status/`,
        {
          match_id: parseInt(matchId),
          analyst_id: parseInt(props.analystId),
        },
        {
          headers: {
            Authorization: `ANALYST ${props.token}`,
          },
        },
      );
      if (res.data.response_data.analysis_event_status) {
        setAnalysisStatus(res.data.response_data.analysis_event_status);
      } else {
        setAnalysisStatus("");
      }

      full();
    } catch (err) {
      console.error(err);
    }
  }, [matchId, props.analystId, props.token]);

  useEffect(() => {
    if (eventLogStatus !== "") {
      updateEventLog({
        matchId: parseInt(matchId),
        analystId: parseInt(props.analystId),
        eventLog: eventLogStatus,
        token: props.token,
      });
    }
  }, [eventLogStatus, matchId, props.analystId, props.token]);

  useEffect(() => {
    if (props.matchString?.[matchId] && props.matchString?.[matchId] !== "") {
      if (props.matchString?.[matchId] !== fullstringanalyse) {
        setFullstringanalyse(props.matchString?.[matchId]);
      }
    }
  }, [props.matchString, matchId]);

  useEffect(() => {
    if (fullstringanalyse !== "") {
      props.SetFullAnalyseString({ id: matchId, string: fullstringanalyse });
    }
  }, [fullstringanalyse, matchId]);

  useEffect(() => {
    const parse = (str) => {
      let stringArr = str.split(",");
      let lastString = stringArr[stringArr.length - 1];
      while (lastString === "X-X-X-X-X-X-X-X-X-X-X-X") {
        stringArr.pop();
        lastString = stringArr[stringArr.length - 1];
      }
      return stringArr.join(",");
    };
    const interval = setInterval(() => {
      if (
        fullstringanalyse !== "" &&
        fullstringanalyse !== "X-X-X-X-X-X-X-X-X-X-X-X"
      ) {
        const match_string = parse(fullstringanalyse);
        if (match_string !== "" && match_string !== "X-X-X-X-X-X-X-X-X-X-X-X") {
          props.PushMatchStringToServer(
            matchId,
            props.analystId,
            match_string,
            props.token,
          );
        }
      }
    }, 90000);
    return () => clearInterval(interval);
  }, [fullstringanalyse, matchId, props.analystId, props.token]);

  useEffect(() => {
    if (matchId && props.all_matches) {
      const details = props.all_matches?.find((m) => {
        return m.id.toString() === matchId;
      });
      details && setMatchDetails(details);
    }
  }, [matchId, props.all_matches]);

  useEffect(() => {
    if (matchDetails) {
      const teamA = matchDetails.team_a_details;
      const teamB = matchDetails.team_b_details;
      teamA && setTeamADetails(teamA);
      teamB && setTeamBDetails(teamB);
    }
  }, [matchDetails]);

  useEffect(() => {
    if (props.analysedata) {
      const teamA =
        props.analysedata.TeamInput &&
        props.analysedata.TeamInput[0].team_id &&
        props.analysedata.TeamInput[0].team_details;
      const teamB =
        props.analysedata.TeamInput &&
        props.analysedata.TeamInput[0].team_id &&
        props.analysedata.TeamInput[1].team_details;
      const teamAPlayerMap = teamA
        ? teamA
          ?.filter((i) => i.lineup_notation === 1)
          ?.map((p) => {
            return p.jersey_number;
          })
        : [];
      const teamBPlayerMap = teamB
        ? teamB
          .filter((i) => i.lineup_notation === 1)
          .map((p) => {
            return p.jersey_number;
          })
        : [];
      const teamASubsPlayerMap = teamA
        ? teamA
          ?.filter((i) => i.lineup_notation === 2)
          ?.map((p) => {
            return p.jersey_number;
          })
        : [];
      const teamBSubsPlayerMap = teamB
        ? teamB
          .filter((i) => i.lineup_notation === 2)
          .map((p) => {
            return p.jersey_number;
          })
        : [];
      setTeamAPlayers(teamAPlayerMap);
      setTeamBPlayers(teamBPlayerMap);
      setTeamASubsPlayers(teamASubsPlayerMap);
      setTeamBSubsPlayers(teamBSubsPlayerMap);
      setTeamAGK(teamA?.find((i) => i.preferred_position === 1)?.jersey_number);
      setTeamBGK(teamB?.find((i) => i.preferred_position === 1)?.jersey_number);
    }
  }, [props.analysedata]);

  const TriggerDialog = (msg) => {
    // setShowDialog(msg);
    // setTimeout(() => {
    //   setShowDialog(null);
    // }, 1500);
    if (msg.color === "tomato") {
      toast.error(msg.msg);
    } else {
      toast.success(msg.msg);
    }
  };

  const FormatString = (string, result) => {
    setFormatProgress(true);
    var a = string;
    let b = a.split(",");
    let count = 0;
    let chckcount = 0;
    let original = [];
    let startTime = "";
    let lastTime = "";
    let den = [];
    let c = [];

    let actionnote;

    for (var i = 0; i < b.length; i++) {
      let c;
      c = b[i].split("-");
      actionnote = c[2] + "-" + c[3];
      // switch (actionnote) {
      //   case "CS-4":
      //     if (i !== b.length - 1) {
      //       let nxtactionnote =
      //         b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
      //       if (nxtactionnote !== "GS-0") {
      //         b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
      //       }
      //     }
      //     break;
      //   case "LS-4":
      //     if (i !== b.length - 1) {
      //       let nxtactionnote =
      //         b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
      //       if (nxtactionnote !== "GS-0") {
      //         b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
      //       }
      //     }
      //     break;
      //   case "H-4":
      //     if (i !== b.length - 1) {
      //       let nxtactionnote =
      //         b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
      //       if (nxtactionnote !== "GS-0") {
      //         b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
      //       }
      //     }
      //     break;

      //   default:
      //     break;
      // }
    }
    a = b.toString();
    b = a.split(",");
    c = [];

    for (let i = 0; i < b.length; i++) {
      let chck = b[i].split("-");

      if (chck[6] !== "X") {
        lastTime = chck[6];
        if (startTime === "") {
          startTime = chck[6];
        }
      }
      original.push({ index: i, str: b[i] });

      if (
        [
          "SP",
          "LP",
          "TB",
          "C",
          "PC",
          "CL",
          "GS",
          "XSP",
          "XLP",
          "XTB",
          "XC",
          "XPC",
          "XCL",
          "XGS",
        ].includes(chck[2])
      ) {
        if (["4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }
      if (["T", "AD", "GD", "XDC", "XAD", "XGD"].includes(chck[2])) {
        if (["2", "3", "4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }

      if (
        [
          "ST",
          "SL",
          "IN",
          "PR",
          "GH",
          "GT",
          "DR",
          "XST",
          "XSL",
          "XIN",
          "XPR",
          "XGH",
          "XGT",
          "XDR",
        ].includes(chck[2])
      ) {
        if (["3", "4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }

      if (
        chck[2] !== "XCL" &&
        chck[2] !== "XPC" &&
        chck[2] !== "XH" &&
        chck[2] !== "X" &&
        chck[1] !== "X" &&
        chck[2] !== "XX" &&
        chck[2] !== "XGS" &&
        chck[2] !== "XGH" &&
        chck[2] !== "XLS" &&
        chck[2] !== "XCS" &&
        chck[2] !== "XDC" &&
        chck[2] !== "XOFF" &&
        chck[2] !== "XPC"
      ) {
        c[count] = { index: i, str: b[i] };
        count++;
      } else {
        den[chckcount] = { index: i, str: b[i] };
        chckcount++;
      }
    }
    a = c;

    let errstring = den;
    setFormatProgress(false);
    result({
      string: a,
      error: errstring,
      original,
      startTime: startTime,
      lastTime: lastTime,
    });
  };
  const handleFormatedString = (result) => {
    const { error, original, lastTime, startTime } = result;
    if (lastTime) {
      setStringLastTime(lastTime);
    }
    if (startTime) {
      setStringStartTime(startTime);
    }

    if (error?.length > 0) {
      setOpenStringFixer(true);
      setErrorStrings(error);
      TriggerDialog({ color: "tomato", msg: "ERROR DETECTED!" });
    } else {
      TriggerDialog({ msg: "GREAT ! NO ERROR!!" });
      openStringFixer && setOpenStringFixer(false);
    }
    if (original) {
      setOriginalForFormating(original);
      setFullstringanalyse(
        original
          .map((o) => o.str)
          .toString()
          .replaceAll(" ", "")
          .replaceAll(",,", ",")
          .replaceAll(",,,", ",")
          .replaceAll("\t", "")
          .replaceAll("\r", "")
          .replaceAll("\n", ""),
      );
    }
  };

  const gotoSubmitHandler = useCallback(() => {
    FormatString(fullstringanalyse, handleFormatedString);
    if (errorStrings?.length > 0) {
      TriggerDialog({
        color: "tomato",
        msg: "ERROR DETECTED ! FORMAT & FIXED IT TO SUBMIT !!",
      });
    }

    if (
      originalForFormating &&
      originalForFormating.length > 0 &&
      (!errorStrings || errorStrings?.length === 0)
    ) {
      props.PushMatchStringToServer(
        matchId,
        props.analystId,
        fullstringanalyse,
        props.token,
      );
      history.push(`/matchupdate/${matchId}`);
    }
  }, [errorStrings, fullstringanalyse, originalForFormating]);

  const mergeErrorToOriginal = () => {
    setErrorStrOnFocus(null);
    if (errorStrings?.length > 0 && originalForFormating?.length > 0) {
      setMergingLoading(true);
      const merged = originalForFormating?.map((s, i) => {
        const found = errorStrings?.find((e) => e.index === s.index);
        if (found) {
          const newError = errorStrings?.filter(
            (e) => e.index.toString() !== found?.index.toString(),
          );
          setErrorStrings(newError);

          return found;
        }
        return s;
      });
      if (merged?.length > 0) {
        const readyStr = merged.map((m) => m.str).toString();
        FormatString(readyStr, handleFormatedString);
        setMergingLoading(false);
      }
    }
  };

  const removeAllErrorFromOriginal = () => {
    let check = window.confirm(
      "This will removed ALL ERROR string. Comfirm ? ",
    );
    if (check) {
      const originalStrs = originalForFormating?.filter((i) => {
        if (errorStrings?.find((d) => d.index === i.index)) {
          return false;
        }
        return true;
      });
      setErrorStrings(null);
      originalStrs &&
        FormatString(
          originalStrs?.map((s) => s.str).toString(),
          handleFormatedString,
        );
    }
  };

  const openFormatterHanlder = () => {
    FormatString(fullstringanalyse, handleFormatedString);
  };

  const confirmSideChange = () => {
    setSecondHalf(!secondHalf);
    setShowSideChangeAlert(false);
    setShowSideChangeAlert2(true);
  };

  const cancelSideChange = () => {
    setShowSideChangeAlert(false);
  };

  const handleSideChange = () => {
    setShowSideChangeAlert(true);
    // if (changed) {
    //   setSecondHalf(!secondHalf);
    // }
  };

  useEffect(() => {
    if (isFullScreen) {
      if (analysisStatus === "" || analysisStatus === "end") {
        setEventLogStatus("start");
      }

      if (
        analysisStatus === "pause" ||
        analysisStatus === "resume" ||
        analysisStatus === "start"
      ) {
        setEventLogStatus("resume");
      }
    } else {
      setEventLogStatus("pause");
    }
  }, [isFullScreen, analysisStatus]);

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {
      setIsFullScreen(screenfull.isFullscreen);
      setIsModalOpen(screenfull.isFullscreen);
      if (screenfull.isFullscreen) {
        if (analysisStatus === "" || analysisStatus === "end") {
          setEventLogStatus("start");
        }

        if (
          analysisStatus === "pause" ||
          analysisStatus === "resume" ||
          analysisStatus === "start"
        ) {
          setEventLogStatus("resume");
        }
      } else {
        setEventLogStatus("pause");
      }
    });
  }

  const onDonePress = () => {
    onSaveStringPress();
    if (isFullScreen) {
      setIsFullScreen(false);
      screenfull.exit();
    }
  };

  const onCopyPress = (val) => {
    if (Clipboard.isAvailable) {
      if (props.matchString?.[matchId]) {
        const copied = Clipboard.setString(props.matchString?.[matchId]);
        if (copied) {
          TriggerDialog({ msg: "String Copied" });
        }
      }
    }
  };

  const onPastePress = async () => {
    // console.log("pressed")
    if (navigator.clipboard) {
      const pasted = await navigator.clipboard.readText();
      if (pasted) {
        let check = window.confirm(
          "This will replace the current analysed string. Comfirm ?",
        );
        if (check) {
          setFullstringanalyse(pasted);
          TriggerDialog({ msg: "String Pasted" });
        } else {
          return null;
        }
      } else {
        TriggerDialog({ msg: "No String Found", color: "tomato" });
      }
    }
  };

  const onSaveStringPress = async () => {
    if (props.matchString?.[matchId] && props.matchString?.[matchId] !== "") {
      await props.PushMatchStringToServer(
        matchId,
        props.analystId,
        fullstringanalyse,
        props.token,
      );
      TriggerDialog({ msg: "SAVED !!" });
    }
  };

  const onLoadSaveStringPress = useCallback(() => {
    const check =
      props.matchString?.[matchId] && props.matchString?.[matchId] === ""
        ? true
        : window.confirm(
          "Fetch saved string from server. Are you sure? This will delete your current local string!",
        );
    check &&
      props.FetchMatchStringFromServer(matchId, props.analystId, props.token);
  }, [
    matchId,
    props.analystId,
    props.matchString,
    props.FetchMatchStringFromServer,
  ]);

  const onSharePress = async () => {
    if (props.matchString?.[matchId]) {
      try {
        const shareData = {
          title: `Analysed String for ${null}`,
          text: props.matchString?.[matchId],
        };

        await navigator.share(shareData);
      } catch (error) {
        alert(error);
      }
    }
  };

  const onClearPress = () => {
    if (props.matchString?.[matchId]) {
      const check = window.confirm(
        "Delete the analyse string. Are you sure? This will not delete the saved string in server !",
      );
      if (check) {
        setCurrAction("X-X-X-X-X-X-X-X-X-X-X-X");
        setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X");
        setSecondActFlag(false);

        props.SetFullAnalyseString({ id: matchId, string: "" });
        setFullstringanalyse("");
      }
    }
  };

  const isIOSDevice = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPadOS 13+ fix
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  const full = () => {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)",
    ).matches;
    try {
      if (!isIOS) {
        if (screenfull.isEnabled) {
          screenfull.request();
        }
      } else {
        if (isIOSDevice()) {
          if (window.navigator.standalone || isStandalone) {
            setIsFullScreen(true);
            setIsModalOpen(true);
          } else {
            TriggerDialog({
              msg: "Please add the website to home screen to continue",
              color: "tomato",
            });
          }
        }
      }
    } catch (err) {
      console.log(err, "ERRRO IN FULL SCREEN FUNCTION");
    }
  };

  const applyZAxisCell = useCallback(
    (cells) => {
      if (!currAction || currAction === "X-X-X-X-X-X-X-X-X-X-X-X") return;

      const parts = currAction.split("-");
      const actionType = parts[2];

      if (!["LS", "CS", "H"].includes(actionType)) {
        TriggerDialog({
          msg: "Z-axis not applicable for this action",
          color: "tomato",
        });
        return;
      }

      while (parts.length < 12) parts.push("X");

      parts[10] = cells.keeper?.value ? String(cells.keeper.value) : "X";
      parts[11] = cells.ball?.value ? String(cells.ball.value) : "X";

      const updatedAction = parts.join("-");
      setCurrAction(updatedAction);
      props.SetCurrentAction(updatedAction);
    },
    [currAction],
  );

  // if current action achanges to any other then also should clear the z axis
  useEffect(() => {
    const type = currAction.split("-")[2];
    if (!["LS", "CS", "H"].includes(type)) {
      setSelectedCells({
        ball: null,
        keeper: null,
      });
      const parts = currAction.split("-");
      if (parts[10] !== "X" || parts[11] !== "X") {
        parts[10] = "X";
        parts[11] = "X";

        const updated = parts.join("-");
        setCurrAction(updated);
        props.SetCurrentAction(updated);
      }
    }
  }, [currAction]);

  // if notation change then also cles z axis.
  useEffect(() => {
    const type = currAction.split("-")[2];
    if (["LS", "CS", "H"].includes(type)) {
      const parts = currAction.split("-");
      if (parts[10] !== "X" || parts[11] !== "X") {
        setSelectedCells({
          ball: null,
          keeper: null,
        });
        parts[10] = "X";
        parts[11] = "X";

        const updated = parts.join("-");
        setCurrAction(updated);
        props.SetCurrentAction(updated);
      }
    }
  }, [notate]);

  // const processElapsedTime = (seconds) => {
  //   const date = new Date(seconds * 1000);
  //   const hh = date.getUTCHours();
  //   const mm = date.getUTCMinutes();
  //   const ss = ("0" + date.getUTCSeconds()).slice(-2);
  //   return `${hh}:${("0" + mm).slice(-2)}:${ss}`;
  // };

  const processElapsedTime = (msValue) => {
    const date = new Date(msValue);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = ("0" + date.getUTCSeconds()).slice(-2);
    const ms = ("00" + date.getUTCMilliseconds()).slice(-3);
    return `${hh}:${("0" + mm).slice(-2)}:${ss}.${ms}`;
  };

  const parseElapsedTime = (timeStr) => {
    const [hhmmss, ms = "0"] = timeStr.split(".");
    const [hh, mm, ss] = hhmmss.split(":").map(Number);
    return (
      hh * 3600000 + mm * 60000 + ss * 1000 + parseInt(ms.padEnd(3, "0")) // Ensure milliseconds is 3 digits
    );
  };

  //player press handler
  const playerPress = async (jNumber, teamAnnot) => {
    // const videoTimeFromServer?.current = await fetchvideoTimeFromServer();
    const validSecondPositions = new Set([
      "SP",
      "LP",
      "C",
      "TB",
      "CS",
      "LS",
      "H",
      "PC",
    ]);
    if (teamAGK === "" || teamBGK === "") {
      TriggerDialog({
        msg: "Please fill the Goalkeeper Jerseys for both the teams",
        color: "tomato",
      });
    } else {
      var a = currAction;
      var b = a.split("-");
      var team = b[0];
      var jersey = b[1];
      var action = b[2];
      var notate = b[3];
      var time = b[6];
      var firstpos = b[4];
      var secndpos = b[5];
      if (
        (team === "X" ||
          jersey === "X" ||
          action === "X" ||
          notate === "X" ||
          time === "X" ||
          firstpos === "X") &&
        currAction !== "X-X-X-X-X-X-X-X-X-X-X-X" &&
        proMode
      ) {
        TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
      } else if (validSecondPositions.has(action) && secndpos === "X") {
        TriggerDialog({
          msg: "Please select the second position",
          color: "tomato",
        });
      } else {
        var playerjersey = teamAnnot + "-" + jNumber;
        if (secActFlag === false) {
          var paction = currAction;
          var gkaction = "";
          if (action === "LS" || action === "CS" || action === "H") {
            var secndps = 80 - parseInt(secndpos) + 1;
            if (notate === "1") {
              if (team === "A") {
                gkaction =
                  ",B-" +
                  teamBGK +
                  "-GS-1-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  (selectedCells?.keeper?.value ?? "X") +
                  "-" +
                  (selectedCells?.ball?.value ?? "X");
              } else if (team === "B") {
                gkaction =
                  ",A-" +
                  teamAGK +
                  "-GS-1-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  (selectedCells?.keeper?.value ?? "X") +
                  "-" +
                  (selectedCells?.ball?.value ?? "X");
              }
            } else if (notate === "4") {
              if (team === "A") {
                gkaction =
                  ",B-" +
                  teamBGK +
                  "-GS-0-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  (selectedCells?.keeper?.value ?? "X") +
                  "-" +
                  (selectedCells?.ball?.value ?? "X");
              } else if (team === "B") {
                gkaction =
                  ",A-" +
                  teamAGK +
                  "-GS-0-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  (selectedCells?.keeper?.value ?? "X") +
                  "-" +
                  (selectedCells?.ball?.value ?? "X");
              }
            }
          }
          // if (videoTimeFromServer?.current === 0) {
          //   return toast.error(
          //     "Timestamp invalid, should be greater than 0 secs",
          //     {
          //       duration: 1000,
          //     }
          //   );
          // }

          if (
            (lastStringTime !== "X" &&
              lastStringTime >
              processElapsedTime(videoTimeFromServer?.current)) ||
            (time !== "X" &&
              time > processElapsedTime(videoTimeFromServer?.current))
          ) {
            return toast.error("Timestamp should be greater than last event", {
              duration: 1000,
            });
          }
          var fulstring;
          if (
            playerSelect !== "X-X" &&
            currAction !== "X-X-X-X-X-X-X-X-X-X-X-X"
          ) {
            if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X") {
              fulstring = fullstringanalyse
                ? fullstringanalyse +
                "," +
                paction +
                "," +
                secondAction +
                gkaction
                : paction + "," + secondAction + gkaction;
              if (gkaction !== "") {
                TriggerDialog({
                  msg: "Goal Keeper Action :" + gkaction + " added to string!",
                  color: "Green",
                });
              }
            } else {
              fulstring = fullstringanalyse + "," + paction + gkaction;
              if (gkaction !== "") {
                TriggerDialog({
                  msg: "Goal Keeper Action :" + gkaction + " added to string!",
                  color: "Green",
                });
              }
            }
          } else {
            fulstring = fullstringanalyse;
          }
          var crpos =
            playerjersey +
            "-X-X-X-X-X-X-X-" +
            halfTag +
            "-" +
            (selectedCells?.keeper?.value ?? "X") +
            "-" +
            (selectedCells?.ball?.value ?? "X");
          setPlayerSelect(playerjersey);
          setStartPos("X");
          setEndPos("X");
          setActionAttrib("X");
          setNotate("X");
          setSpecialAction("X");
          setPrevAction(paction);
          setCurrAction(crpos);
          setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X");
          setSecondActFlag(true);
          setFullstringanalyse(fulstring);
        } else {
          var secondpos;

          if (endPos !== "X") {
            secondpos = endPos;
          } else {
            secondpos = startPos;
          }
          if (
            currAction.charAt(0) !== playerjersey.charAt(0) &&
            secondpos !== "X"
          ) {
            secondpos = 80 - parseInt(secondpos) + 1;
          }

          var secAttr =
            playerjersey +
            "-X" +
            actionAttrib +
            "-" +
            notate +
            "-" +
            secondpos +
            "-X-" +
            processElapsedTime(videoTimeFromServer?.current) +
            "-X-X-" +
            halfTag +
            "-" +
            (selectedCells?.keeper?.value ?? "X") +
            "-" +
            (selectedCells?.ball?.value ?? "X");

          if (actionAttrib === "AD" || actionAttrib === "GD") {
            var initplyr = currAction.substr(0, currAction.indexOf("-", 2));
            var additionact =
              playerjersey +
              "-" +
              actionAttrib +
              `-${notate === "1" ? 0 : 1}-` +
              (80 - startPos + 1) +
              "-X-" +
              processElapsedTime(videoTimeFromServer?.current) +
              "-X-X-" +
              halfTag +
              "-X-X" +
              "," +
              initplyr +
              "-X" +
              actionAttrib +
              `-${notate === "1" ? 0 : 1}-` +
              startPos +
              "-X-" +
              processElapsedTime(videoTimeFromServer?.current) +
              "-X-X-" +
              halfTag +
              "-X-X";
            secAttr = secAttr + "," + additionact;
          }

          var errorPlayer = 0;
          // receiver team validation based on action type
          if (actionAttrib === "DL") {
            // direct link must have receiver on opposite team
            if (currAction.charAt(0) === playerjersey.charAt(0)) {
              errorPlayer = 1;
            }
          } else if (
            (actionAttrib === "SP" ||
              actionAttrib === "LP" ||
              actionAttrib === "TB" ||
              actionAttrib === "C" ||
              actionAttrib === "GT") &&
            currAction.charAt(0) !== playerjersey.charAt(0)
          ) {
            errorPlayer = 1;
          } else if (
            (actionAttrib === "ST" ||
              actionAttrib === "SL" ||
              actionAttrib === "IN" ||
              actionAttrib === "DR" ||
              actionAttrib === "AD" ||
              actionAttrib === "GD" ||
              actionAttrib === "PR") &&
            currAction.charAt(0) === playerjersey.charAt(0)
          ) {
            errorPlayer = 1;
          }

          if (errorPlayer === 0) {
            setSecondAction(secAttr);
            props.AddToActionLog({ mode: "r", str: secAttr });
            props.SetCurrentAction(secAttr);
            setSecondActFlag(false);
            setSelectedCells({
              ball: null,
              keeper: null,
            });
          } else {
            TriggerDialog({
              msg: "Please select the correct team player",
              color: "tomato",
            });
          }
        }
      }
    }
  };

  const startingTime = useRef(0);
  // limit toast to a max of 4
  const { toasts } = useToasterStore();

  const TOAST_LIMIT = 3;

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  const onFieldPress = (position) => {
    if (playerSelect === "X-X") {
      toast.error("Please select the player jersey before tagging!!", {
        duration: 1250,
      });
      return;
    }

    // if current action is DL, ensure both positions known before allowing any change
    if (
      currAction.split("-")[2] === "DL" &&
      (startPos === "X" || endPos === "X")
    ) {
      TriggerDialog({
        msg: "Both start and end positions are required for DL",
        color: "tomato",
      });
      return;
    }

    const validSecondPositions = new Set([
      "SP",
      "LP",
      "C",
      "TB",
      "CS",
      "LS",
      "H",
      "PC",
    ]);
    var pos = position;
    var criticalzone = [
      11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63,
    ];
    var flankzone = [
      1, 2, 3, 4, 11, 12, 13, 14, 61, 62, 63, 64, 71, 72, 73, 74,
    ];
    var pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];
    var jersey_no = playerSelect;
    var team_nm = jersey_no.substring(0, 1);
    var secndhalf = secondHalf;
    var a = currAction;
    var b = a.split("-");
    var team = b[0];
    var jersey = b[1];
    var action = b[2];
    var notate = b[3];
    var time = b[6];
    var firstpos = b[4];
    const secondpos = b[5];
    var att = "X",
      nottn = "X",
      hfoot = "R";
    if (secndhalf === false) {
      if (team_nm === "A") {
        pos = 80 - parseInt(position) + 1;
      }
    } else {
      if (team_nm === "B") {
        pos = 80 - parseInt(position) + 1;
      }
    }

    var crpos;

    if (startPos === "X") {
      startingTime.current = videoTimeFromServer?.current;
      crpos =
        playerSelect +
        "-" +
        actionAttrib +
        "-" +
        notate +
        "-" +
        pos +
        "-" +
        endPos +
        "-X-X-X-" +
        halfTag +
        "-X-X";
      setStartPos(pos);
      setCurrAction(crpos);
    } else if (endPos === "X" && actionAttrib === "X") {
      var mainstpos = parseInt(startPos);
      var mainenpos = parseInt(pos);

      const passClassification = classifyPassType(mainstpos, mainenpos);
      att = passClassification.type;
      nottn = passClassification.notation;
      // if (videoTimeFromServer?.current === 0) {
      //   return toast.error("Timestamp invalid, should be greater than 0 secs", {
      //     duration: 1000,
      //   });
      // }
      if (
        lastStringTime !== "X" &&
        lastStringTime > processElapsedTime(videoTimeFromServer?.current)
      ) {
        return toast.error("Timestamp should be greater than last event", {
          duration: 1000,
        });
      }
      crpos =
        playerSelect +
        "-" +
        att +
        "-" +
        nottn +
        "-" +
        startPos +
        "-" +
        pos +
        "-" +
        processElapsedTime(startingTime?.current) +
        "-" +
        hfoot +
        "-X-" +
        halfTag +
        "-X-X";
      setEndPos(pos);
      setCurrAction(crpos);
      setActionAttrib(att);
      setNotate(nottn);
    } else if (
      startPos !== "X" &&
      playerSelect !== "X-X" &&
      actionAttrib !== "X" &&
      proMode
    ) {
      if (
        (team === "X" ||
          jersey === "X" ||
          action === "X" ||
          notate === "X" ||
          time === "X" ||
          firstpos === "X") &&
        proMode
      ) {
        TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
      } else {
        if (validSecondPositions.has(action) && secondpos === "X") {
          TriggerDialog({
            msg: "Please select the second position",
            color: "tomato",
          });
        } else {
          var secndactn = secondAction;
          crpos =
            playerSelect +
            "-X-X-" +
            pos +
            "-X-X-X-X-" +
            halfTag +
            "-" +
            (selectedCells?.keeper?.value ?? "X") +
            "-" +
            (selectedCells?.ball?.value ?? "X");
          var paction = currAction;
          var fulstring;
          if (playerSelect !== "X-X") {
            if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X") {
              fulstring =
                fullstringanalyse + "," + paction + "," + secondAction;
              secndactn = "X-X-X-X-X-X-X-X-X-X-X-X";
            } else {
              fulstring = fullstringanalyse + "," + paction;
            }
          } else {
            fulstring = fullstringanalyse;
          }
          setStartPos(pos);
          setEndPos("X");
          setActionAttrib("X");
          setNotate("X");
          setCurrAction(crpos);
          setPrevAction(paction);
          setSecondActFlag(true);
          setFullstringanalyse(fulstring);
          setSecondAction(secndactn);
          setSelectedCells({
            ball: null,
            keeper: null,
          }); //  clear
        }
      }
    } else {
      TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
    }
  };

  const handleSub = async () => {
    // await fetchvideoTimeFromServer();
    setShowSubstitutionModal(true);
  };

  //Half Tagging handler
  const onHalfTag = (key) => {
    switch (key) {
      case "FHN":
        setHalfTag("FHI");
        break;
      case "FHI":
        setHalfTag("SHN");
        break;
      case "SHN":
        setHalfTag("SHI");
        break;
      case "SHI":
        setHalfTag("ET1N");
        break;
      case "ET1N":
        setHalfTag("ET1I");
        break;
      case "ET1I":
        setHalfTag("ET2N");
        break;
      case "ET2N":
        setHalfTag("ET2I");
        break;
      case "ET2I":
        setHalfTag("PK");
        break;
      case "PK":
        setHalfTag("FHN");
        break;
    }
  };

  const Z_AXIS_EVENTS = ["H", "LS", "CS"];

  useEffect(() => {
    if (!currAction || currAction === "X-X-X-X-X-X-X-X-X-X-X-X") {
      setShowZButton(false);
      return;
    }

    const actionType = currAction.split("-")[2];
    setShowZButton(Z_AXIS_EVENTS.includes(actionType));
  }, [currAction]);

  function parseTimeToSeconds(timeStr) {
    const parts = timeStr.split(":").map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) {
      return parts[0] * 60 + parts[1];
    } else {
      return parseInt(parts[0], 10);
    }
  }

  function getSubstitutedOutPlayers(subData) {
    const entries = subData.split(",");
    const outMap = new Map(); // playerId -> { team, jr, time }
    const inMap = new Map(); // playerId -> [times]

    for (const entry of entries) {
      const parts = entry.split("-");
      if (parts.length < 7) continue;

      const team = parts[0];
      const jr = parseInt(parts[1], 10);
      const status = parts[2];
      const timeStr = parts[6];
      const playerId = `${team}-${jr}`;

      const timeInSeconds = parseTimeToSeconds(timeStr);

      if (status === "XSUB") {
        // Save time when player went out
        outMap.set(playerId, { team, jr, timeStr, timeInSeconds });
      } else if (status === "SUB") {
        if (!inMap.has(playerId)) inMap.set(playerId, []);
        inMap.get(playerId).push(timeInSeconds);
      }
    }

    // Now filter out any players who came back after going out
    for (const [playerId, outInfo] of outMap.entries()) {
      const subTimes = inMap.get(playerId) || [];

      const cameBackLater = subTimes.some(
        (inTime) => inTime > outInfo.timeInSeconds,
      );

      if (cameBackLater) {
        outMap.delete(playerId);
      }
    }

    return Array.from(outMap.values());
  }

  function getSubstitutedInPlayers(subData) {
    const entries = subData.split(",");
    const inMap = new Map(); // playerId -> { team, jr, timeStr, timeInSeconds }
    const outMap = new Map(); // playerId -> [times]

    for (const entry of entries) {
      const parts = entry.split("-");
      if (parts.length < 7) continue;

      const team = parts[0];
      const jr = parseInt(parts[1], 10);
      const status = parts[2];
      const timeStr = parts[6];
      const timeInSeconds = parseTimeToSeconds(timeStr);
      const playerId = `${team}-${jr}`;

      if (status === "SUB") {
        inMap.set(playerId, { team, jr, timeStr, timeInSeconds });
      } else if (status === "XSUB") {
        if (!outMap.has(playerId)) outMap.set(playerId, []);
        outMap.get(playerId).push(timeInSeconds);
      }
    }

    // Remove players who went out after coming in
    for (const [playerId, inInfo] of inMap.entries()) {
      const outTimes = outMap.get(playerId) || [];

      const wentOutLater = outTimes.some(
        (outTime) => outTime > inInfo.timeInSeconds,
      );

      if (wentOutLater) {
        inMap.delete(playerId);
      }
    }

    return Array.from(inMap.values());
  }

  const parts = fullstringanalyse?.split(",");
  const lastFive = parts.slice(-5);

  const lastString = parts?.pop();
  const lastStringTime = lastString?.split("-")?.[6];
  const lastStringAction = lastString?.split("-")?.[2];
  const lastStringEvent = ["XST", "XSL"]?.includes(lastStringAction)
    ? parts?.[parts?.length - 1]?.split("-")?.[8]
    : ["XAD", "XGD"]?.includes(lastStringAction)
      ? parts?.[parts?.length - 3]?.split("-")?.[8]
      : lastStringAction !== "X" && lastStringAction?.includes("X")
        ? parts?.[parts?.length - 2]?.split("-")?.[8]
        : lastString?.split("-")?.[8];

  const outPlayers = getSubstitutedOutPlayers(fullstringanalyse);
  const inPlayers = getSubstitutedInPlayers(fullstringanalyse);

  //key press handler
  const onKeyPress = async (key) => {
    if (
      key === "G" &&
      !["LP", "SP", "TB"].includes(currAction?.split("-")?.[2])
    ) {
      toast.error("G can only be tagged for Passing.");
      return;
    }
    key = key + "";
    const arr = fullstringanalyse?.split(",");

    // // disable notation 2, 3 and 4 when direct link is active
    // if (key !== "1" && actionAttrib === "DL") {
    //   TriggerDialog({
    //     msg: "Notation 1 is only allowed for DL",
    //     color: "tomato",
    //   });
    //   return;
    // }

    if (Z_AXIS_EVENTS.has(key)) setShowZButton(true);

    var stpos, enpos, jerseyno, teamnm, sechaf;
    stpos = parseInt(startPos);
    enpos = endPos === "X" ? "X" : parseInt(endPos);
    jerseyno = playerSelect;
    teamnm = jerseyno.substring(0, 1);
    var defcriticalzone = [
      18, 19, 20, 28, 29, 30, 38, 39, 40, 48, 49, 50, 58, 59, 60, 68, 69, 70,
    ];
    var criticalzone = [
      11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63,
    ];
    var flankzone = [
      1, 2, 3, 4, 11, 12, 13, 14, 61, 62, 63, 64, 71, 72, 73, 74,
    ];
    var pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];
    var mainstpos, mainenpos;

    var new_att = "X",
      new_speclact = "X",
      new_nottn = "X";
    var att = "X",
      nottn = "X",
      speclact = "X",
      hfoot = "R";
    var prevact = prevAction;
    switch (key) {
      case "BACK SPACE":
        var ex = "X";
        var exes = "X-X";
        var multiex = "X-X-X-X-X-X-X-X-X-X-X-X";
        att = "X";
        nottn = "X";
        hfoot = "X";
        setStartPos(ex);
        setEndPos(ex);
        setPlayerSelect(exes);
        setSelectedCells({
          ball: null,
          keeper: null,
        });
        setActionAttrib(ex);
        setNotate(ex);
        setCurrAction(multiex);
        setSecondAction(multiex);
        setSecondActFlag(false);
        setElapseTime(ex);
        setSpecialAction(ex);
        setActFoot(ex);

        break;
      case "X":
        att = actionAttrib;
        nottn = "0";
        break;
      case "0":
        att = actionAttrib;
        nottn = "0";
        break;
      case "1":
        att = actionAttrib;
        nottn = "1";
        break;
      case "2":
        att = actionAttrib;
        nottn = "2";
        break;
      case "3":
        att = actionAttrib;
        nottn = "3";
        break;
      case "4":
        att = actionAttrib;
        nottn = "4";
        break;
      case "IN":
        mainenpos = enpos;
        mainstpos = stpos;
        att = "IN";

        if (defcriticalzone.indexOf(mainstpos) === -1) {
          nottn = "1";
        } else {
          nottn = "2";
        }
        break;
      case "PS":
        mainstpos = stpos;
        mainenpos = enpos;

        const passClassification = classifyPassType(mainstpos, mainenpos, true);
        att = passClassification.type;
        nottn = passClassification.notation;

        break;
      case "SP":
        att = "SP";
        nottn = "1";
        break;
      case "LP":
        att = "LP";
        nottn = "1";
        break;
      case "C":
        att = "C";
        nottn = "1";
        break;
      case "DR":
        mainstpos = stpos;
        mainenpos = "X";

        att = "DR";
        if (criticalzone.indexOf(mainstpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "AD":
        mainstpos = stpos;
        mainenpos = "X";

        att = "AD";
        nottn = "1";

        break;
      case "GD":
        mainstpos = stpos;
        mainenpos = "X";

        att = "GD";
        nottn = "1";

        break;
      case "CL":
        mainenpos = enpos;
        mainstpos = stpos;
        att = "CL";

        if (mainstpos === 40 || mainstpos === 50) {
          nottn = "3";
        } else if (
          mainstpos === 29 ||
          mainstpos === 30 ||
          mainstpos === 39 ||
          mainstpos === 49 ||
          mainstpos === 59 ||
          mainstpos === 60
        ) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "TB":
        att = "TB";

        mainstpos = stpos;
        mainenpos = enpos;
        if (pboxzone.indexOf(mainenpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "T":
        mainenpos = "X";
        mainstpos = stpos;
        att = "T";
        nottn = "1";
        break;
      case "PC":
        att = "PC";

        mainstpos = stpos;
        mainenpos = enpos;
        if (
          mainstpos === mainenpos ||
          mainstpos + 1 === mainenpos ||
          mainstpos - 1 === mainenpos ||
          mainstpos + 11 === mainenpos ||
          mainstpos + 10 === mainenpos ||
          mainstpos + 9 === mainenpos ||
          mainstpos - 10 === mainenpos ||
          mainstpos - 9 === mainenpos ||
          mainstpos - 11 === mainenpos
        ) {
          nottn = "1";
        } else if (
          mainstpos + 2 === mainenpos ||
          mainstpos - 2 === mainenpos ||
          mainstpos + 12 === mainenpos ||
          mainstpos + 20 === mainenpos ||
          mainstpos + 19 === mainenpos ||
          mainstpos - 20 === mainenpos ||
          mainstpos - 19 === mainenpos ||
          mainstpos - 12 === mainenpos ||
          mainstpos - 22 === mainenpos ||
          mainstpos + 22 === mainenpos ||
          mainstpos - 18 === mainenpos ||
          mainstpos + 18 === mainenpos ||
          mainstpos - 21 === mainenpos ||
          mainstpos + 21 === mainenpos ||
          mainstpos - 8 === mainenpos ||
          mainstpos + 8 === mainenpos
        ) {
          nottn = "2";
        } else {
          nottn = "3";
        }

        break;
      case "GS":
        att = "GS";
        nottn = "1";

        break;
      case "GT":
        att = "GT";
        nottn = "1";

        break;
      case "GH":
        att = "GH";
        nottn = "1";
        break;
      case "ST":
        att = "ST";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;
      case "SHT":
        //TODO: IMPLEMENT PASS ANALYZER
        const _arr = fullstringanalyse?.split(",");
        let currSHT = currAction.split("-");
        if (pboxzone.indexOf(stpos) !== -1) {
          att = "CS";
          currSHT[2] = "CS";
        } else {
          att = "LS";
          currSHT[2] = "LS";
        }
        nottn = "1";
        currSHT = currSHT.join("-");
        const error = passAnalyzer(currSHT, _arr.length - 1, _arr);
        if (error) {
          TriggerDialog({
            msg: error,
            color: "tomato",
          });
        }
        break;
      case "CS":
        att = "CS";
        nottn = "1";
        break;
      case "LS":
        att = "LS";
        nottn = "1";
        break;
      case "H":
        att = "H";
        nottn = "1";
        break;
      case "SL":
        att = "SL";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;

      //STOP EVENT

      case "STP":
        new_att = "STOP";
        new_nottn = "1";
        new_speclact = specialAction;

        break;
      case "OUT":
        // att = "OUT";
        // nottn = "1";
        // speclact = "X";
        new_att = "OUT";
        new_nottn = "1";
        new_speclact = "X";

        break;
      case "DRP":
        // const lastAtt = fullstringanalyse?.split(",")?.pop()?.split("-")?.[2];
        // const lastSpAct = fullstringanalyse?.split(",")?.pop()?.split("-")?.[8];
        // if (
        //   !["F", "RC", "YC"]?.includes(currAction?.split("-")?.[8]) &&
        //   lastAtt !== "STOP" &&
        //   lastAtt === "STOP" &&
        //   !["F", "OFF"]?.includes(lastSpAct)
        // )
        let hasStopFollowedByDB = false;

        for (let i = 0; i < lastFive.length - 1; i++) {
          const current = lastFive[i];
          const next = lastFive[i + 1];

          if (current.includes("STOP") && next.includes("DB")) {
            hasStopFollowedByDB = true;
            break;
          }
        }
        const hasSTOPDB = lastFive.some((part) => part.includes("STOP"));
        if (!hasSTOPDB && !hasStopFollowedByDB) {
          return toast.error("Cannot tag Dropball event without STOP", {
            duration: 1000,
          });
        } else {
          att = actionAttrib;
          nottn = notate;
          new_att = actionAttrib;
          new_nottn = notate;
          speclact = "DB";
        }

        break;

      // Type 1 setting =======================================================

      case "PR":
        att = "PR";
        nottn = "1";
        break;
      case "OFF":
        att = "OFF";
        nottn = "1";
        break;
      case "THW":
        let hasOutFollowedByThw = false;

        for (let i = 0; i < lastFive.length - 1; i++) {
          const current = lastFive[i];
          const next = lastFive[i + 1];

          if (current.includes("OUT") && next.includes("THW")) {
            hasOutFollowedByThw = true;
            break;
          }
        }
        const hasOUT = lastFive.some((part) => part.includes("OUT"));
        if (!hasOUT && !hasOutFollowedByThw) {
          return toast.error("Cannot tag THROW event without OUT", {
            duration: 1000,
          });
        }
        att = "THW";
        nottn = "1";
        break;
      case "DL":
        att = "DL";
        nottn = "1";
        break;
      case "HB":
        att = "HB";
        nottn = "1";
        break;
      case "L":
        att = actionAttrib;
        nottn = notate;
        hfoot = "L";
        speclact = specialAction;
        break;
      case "R":
        att = actionAttrib;
        nottn = notate;
        hfoot = "R";
        speclact = specialAction;
        break;

      // Type 2 and 4 setting ================================

      case "CN":
        att = actionAttrib;
        nottn = notate;
        speclact = "CN";
        break;
      case "FK":
        //TODO: freeKickAnalyzerHelper
        let currFk = currAction.split("-");
        att = actionAttrib;
        nottn = notate;
        speclact = "FK";
        currFk[8] = speclact;
        currFk = currFk.join("-");
        const fkError = freeKickAnalyzer(currFk, arr.length - 1, arr);
        if (fkError) {
          setShowBoxAlert(true);
        }
        break;
      case "PK":
        //TODO: freeKickAnalyzerHelper
        att = actionAttrib;
        nottn = notate;
        speclact = "PK";
        let currPk = currAction.split("-");
        currPk[8] = speclact;
        currPk = currPk.join("-");
        const pkError = freeKickAnalyzer(currPk, arr.length - 1, arr);
        if (pkError) {
          setShowBoxAlert(true);
        }
        break;
      case "MC":
        att = "MC";
        nottn = "1";

        break;
      case "F":
        att = actionAttrib;
        nottn = notate;
        speclact = "F";
        break;

      case "RC":
        att = actionAttrib;
        nottn = notate;
        speclact = "RC";
        break;
      case "YC":
        att = actionAttrib;
        nottn = notate;
        speclact = "YC";
        break;
      case "GK":
        att = actionAttrib;
        nottn = notate;
        speclact = "GK";
        break;
      case "OG":
        att = actionAttrib;
        nottn = notate;
        speclact = "OG";
        break;

      default:
        break;
    }
    // if (key !== "BACK SPACE" && videoTimeFromServer?.current === 0) {
    //   return toast.error("Timestamp invalid, should be greater than 0 secs", {
    //     duration: 1000,
    //   });
    // }
    if (
      key !== "BACK SPACE" &&
      lastStringTime !== "X" &&
      lastStringTime > processElapsedTime(videoTimeFromServer?.current)
    ) {
      return toast.error("Timestamp should be greater than last event", {
        duration: 1000,
      });
    }
    if (key !== "BACK SPACE") {
      let time;

      if (currAction?.split("-")?.[6] !== "X") {
        time = currAction?.split("-")?.[6];
      } else {
        time = processElapsedTime(videoTimeFromServer?.current);
      }

      if (
        time !== "X" &&
        time > processElapsedTime(videoTimeFromServer?.current)
      ) {
        return toast.error("Timestamp should be greater than last event", {
          duration: 1000,
        });
      }

      var crpos =
        playerSelect +
        "-" +
        att +
        "-" +
        nottn +
        "-" +
        startPos +
        "-" +
        endPos +
        "-" +
        time +
        "-" +
        hfoot +
        "-" +
        speclact +
        "-" +
        halfTag +
        "-" +
        (selectedCells?.keeper?.value ?? "X") +
        "-" +
        (selectedCells?.ball?.value ?? "X");
    } else {
      crpos = "X-X-X-X-X-X-X-X-X-X-X-X";
    }
    var secondpos;
    if (endPos !== "X") {
      secondpos = endPos;
    } else {
      secondpos = startPos;
    }

    var secattri = "X-X-X" + att + "-" + nottn + "-" + secondpos + "-X-X-X-X";

    const curPlayer = playerSelect;

    if (key === "OUT") {
      // let videoTimeFromServer?.current = await fetchvideoTimeFromServer();

      var stopevt =
        currAction?.split("-")?.[0] +
        "-" +
        currAction?.split("-")?.[1] +
        "-" +
        new_att +
        "-" +
        new_nottn +
        "-" +
        "X" +
        "-" +
        "X" +
        "-" +
        processElapsedTime(videoTimeFromServer?.current) +
        "-" +
        "X" +
        "-" +
        "X" +
        "-" +
        halfTag +
        "-" +
        (selectedCells?.keeper?.value ?? "X") +
        "-" +
        (selectedCells?.ball?.value ?? "X");
      var fulstring;

      if (
        curPlayer !== "X-X" &&
        currAction?.split("-")?.[0] + "-" + currAction?.split("-")?.[1] !==
        "X-X" &&
        new_att !== "X"
      ) {
        if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X") {
          fulstring =
            fullstringanalyse +
            "," +
            currAction +
            "," +
            secondAction +
            "," +
            stopevt;
        } else if (
          currAction?.split("-")?.[2] + "-" + currAction?.split("-")?.[3] !==
          "X-X"
        ) {
          fulstring = fullstringanalyse + "," + currAction + "," + stopevt;
        } else {
          fulstring = fullstringanalyse + "," + stopevt;
        }
      } else {
        fulstring = fullstringanalyse;
      }
      setPrevAction(currAction);
      setCurrAction("X-X-X-X-X-X-X-X-X-X-X-X");
      setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X");
      setSecondActFlag(false);
      setActionAttrib("X");
      setNotate("X");

      setSpecialAction("X");
      setActFoot("X");
      props.SetCurrentAction("X-X-X-X-X-X-X-X-X-X-X-X");
      // setActionAttrib(att);
      // setNotate(nottn);
      // setCurrAction(crpos);
      // setSpecialAction(speclact);
      // setActFoot(hfoot);
      // props.SetCurrentAction(crpos);
      key !== "BACK SPACE" &&
        props.AddToActionLog({ mode: "p", str: currAction });
      setFullstringanalyse(fulstring);
    } else if (key === "STP") {
      if (["AD", "GD"]?.includes(currAction?.split("-")?.[2])) {
        if (currAction?.split("-")?.[8] === "X") {
          return toast.error("Last Special Actions not detected to STOP");
        }
      }

      if (["ST", "SL"]?.includes(currAction?.split("-")?.[2])) {
        if (currAction?.split("-")?.[8] === "X") {
          return toast.error("Last Special Actions not detected to STOP");
        }
      }
      // if (!["AD", "GD", "HB"]?.includes(currAction?.split("-")?.[2])) {
      //   if (lastStringAction === "X") {
      //     return toast.error("Last Event Actions not detected to STOP");
      //   }
      //   // if (lastStringAction === "OUT") {
      //   //   return toast.error("Last Event Actions not detected to STOP");
      //   // }
      //   if (lastStringAction === "STOP") {
      //     return toast.error("Last Event Actions not detected to STOP");
      //   }
      //   if (lastStringAction === "CS" && lastString?.split("-")?.[3] === "4") {
      //   }
      //   if (lastStringAction === "GS" && lastString?.split("-")?.[3] === "0") {
      //   } else {
      //     if (
      //       lastStringAction !== "OFF" &&
      //       lastStringAction !== "XOFF" &&
      //       lastStringAction !== "HB" &&
      //       lastStringAction !== "XHB" &&
      //       lastStringEvent === "X"
      //     ) {
      //       return toast.error("Last Special Actions not detected to STOP");
      //     }
      //   }
      // }

      // if (currAction?.split("-")?.[8] === "X") {
      //   return toast.error("Last Special Actions not detected to STOP");
      // }
      // let videoTimeFromServer?.current = await fetchvideoTimeFromServer();
      var modedAct;
      if (
        currAction?.split("-")?.[2] === "OFF" ||
        lastStringEvent === "OFF" ||
        lastStringEvent === "XOFF"
      ) {
        modedAct = "OFF";
      }
      if (
        currAction?.split("-")?.[2] === "HB" ||
        lastStringEvent === "HB" ||
        currAction?.split("-")?.[2] === "XHB" ||
        lastStringEvent === "XHB"
      ) {
        modedAct = "HB";
      } else if (currAction?.split("-")?.[8] === "RC") {
        modedAct = "RC";
      } else if (["YC", "RC", "CN", "F", "GK", "RC"]?.includes(specialAction)) {
        modedAct = specialAction;
      } else {
        modedAct = lastStringEvent;
      }
      var stopevt =
        curPlayer +
        "-" +
        new_att +
        "-" +
        new_nottn +
        "-" +
        "X" +
        "-" +
        "X" +
        "-" +
        processElapsedTime(videoTimeFromServer?.current) +
        "-" +
        hfoot +
        "-" +
        modedAct +
        "-" +
        halfTag +
        "-" +
        (selectedCells?.keeper?.value ?? "X") +
        "-" +
        (selectedCells?.ball?.value ?? "X");
      var fulstring;
      if (
        playerSelect !== "X-X" &&
        currAction?.split("-")?.[0] + "-" + currAction?.split("-")?.[1] !==
        "X-X" &&
        new_att !== "X"
      ) {
        if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X") {
          fulstring =
            fullstringanalyse +
            "," +
            currAction +
            "," +
            secondAction +
            "," +
            stopevt;
        } else if (
          currAction?.split("-")?.[2] + "-" + currAction?.split("-")?.[3] !==
          "X-X"
        ) {
          fulstring = fullstringanalyse + "," + currAction + "," + stopevt;
        } else {
          fulstring = fullstringanalyse + "," + stopevt;
        }
      } else {
        fulstring = fullstringanalyse;
      }
      setPrevAction(currAction);
      setCurrAction("X-X-X-X-X-X-X-X-X-X-X-X");
      setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X");
      setSecondActFlag(false);
      setActionAttrib("X");
      setNotate("X");

      setSpecialAction("X");
      setActFoot("X");
      props.SetCurrentAction("X-X-X-X-X-X-X-X-X-X-X-X");
      setFullstringanalyse(fulstring);
    } else {
      setActionAttrib(att);
      setNotate(nottn);
      setCurrAction(crpos);
      setSpecialAction(speclact);
      setActFoot(hfoot);
      props.SetCurrentAction(crpos);
      key !== "BACK SPACE" && props.AddToActionLog({ mode: "p", str: crpos });
    }
  };

  const onSubtituteUpdate = ({ team, outPlayer, inPlayer, time }) => {
    var crpos = "X-X-X-X-X-X-X-X-X-X-X-X";
    var outPlayerEvt =
      team +
      "-" +
      inPlayer +
      "-" +
      "SUB" +
      "-" +
      "1" +
      "-" +
      "X" +
      "-" +
      "X" +
      "-" +
      processElapsedTime(time) +
      "-" +
      "X" +
      "-" +
      "X" +
      "-" +
      halfTag +
      "-" +
      (selectedCells?.keeper?.value ?? "X") +
      "-" +
      (selectedCells?.ball?.value ?? "X");
    var inPlayerEvt =
      team +
      "-" +
      outPlayer +
      "-" +
      "XSUB" +
      "-" +
      "1" +
      "-" +
      "X" +
      "-" +
      "X" +
      "-" +
      processElapsedTime(time) +
      "-" +
      "X" +
      "-" +
      "X" +
      "-" +
      halfTag;

    var fulstring = fullstringanalyse + "," + outPlayerEvt + "," + inPlayerEvt;
    setFullstringanalyse(fulstring);
    toast("Substitutions event added!!");

    setCurrAction(crpos);
    setSecondAction(crpos);
    setSecondActFlag(true);
    // props.SetCurrentAction(outPlayerEvt);
    // props.AddToActionLog({ mode: "p", str: outPlayerEvt });
  };

  // next press handler
  const onNextPress = () => {
    var a = currAction;
    var b = a.split("-");
    var team = b[0];
    var jersey = b[1];
    var action = b[2];
    var notate = b[3];
    var time = b[6];
    var firstpos = b[4];
    var secndpos = b[5];

    // if LS-0, CS-0 , and H-0 then dsiabled the nct btn
    const isShotAction = ["LS", "CS", "H"].includes(action);
    const isOffTarget = notate === "0";
    const zMissing =
      currAction.split("-")[10] === "X" || currAction.split("-")[11] === "X";

    if (isShotAction && !isOffTarget && zMissing) {
      toast.error("Please add the Z axis value to proceed further!!", {
        duration: 1500,
      });
      return;
    }

    // both positions required for DL
    if ((firstpos === "X" || secndpos === "X") && action === "DL") {
      TriggerDialog({
        msg: "Both start and end positions are required for DL",
        color: "tomato",
      });
      return;
    }

    if (
      (action === "SP" ||
        action === "LP" ||
        action === "C" ||
        action === "TB" ||
        action === "GT" ||
        action === "ST" ||
        action === "SL" ||
        action === "IN" ||
        action === "DR" ||
        action === "AD" ||
        action === "GD" ||
        action === "PR") &&
      notate > 0
    ) {
      TriggerDialog({
        msg: "Please select the receiving player jersey",
        color: "tomato",
      });
    } else {
      setSecondActFlag(false);
    }
  };

  const outTeamA = (outPlayers ?? [])
    .filter((i) => i?.team === "A")
    .map((p) => p?.jr);
  const outTeamB = (outPlayers ?? [])
    .filter((i) => i?.team === "B")
    .map((p) => p?.jr);

  const inTeamA = (inPlayers ?? [])
    .filter((i) => i?.team === "A")
    .map((p) => p?.jr);
  const inTeamB = (inPlayers ?? [])
    .filter((i) => i?.team === "B")
    .map((p) => p?.jr);

  const teamAPlayersSorted = [
    ...(teamAPlayers ?? []).filter(
      (player) => !outTeamA.includes(Number(player)),
    ),
    ...(teamASubsPlayers ?? []).filter((player) =>
      inTeamA.includes(Number(player)),
    ),
  ];

  const teamASubsPlayerSorted = [
    ...(teamASubsPlayers ?? []).filter(
      (player) => !inTeamA.includes(Number(player)),
    ),
    ...(teamAPlayers ?? []).filter((player) =>
      outTeamA.includes(Number(player)),
    ),
  ];

  const teamBPlayersSorted = [
    ...(teamBPlayers ?? []).filter(
      (player) => !outTeamB.includes(Number(player)),
    ),
    ...(teamBSubsPlayers ?? []).filter((player) =>
      inTeamB.includes(Number(player)),
    ),
  ];

  const teamBSubsPlayerSorted = [
    ...(teamBSubsPlayers ?? []).filter(
      (player) => !inTeamB.includes(Number(player)),
    ),
    ...(teamBPlayers ?? []).filter((player) =>
      outTeamB.includes(Number(player)),
    ),
  ];

  //RENDER START
  if (closeRequested) {
    return (
      <View
        style={{
          flex: 1,
          padding: 20,
          backgroundColor: "#fff",
          width: "100%",
          height: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: width / 100 }}>CLOSING CONTROLLER WINDOW</Text>
        <ActivityIndicator />
      </View>
    );
  }

  if (!width) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#131313",
          zIndex: 1,
        }}
        onLayout={(e) => {
          setWidth(e.nativeEvent.layout.width);
          setHeight(e.nativeEvent.layout.height);
        }}
      >
        <ActivityIndicator />
        <Text style={{ color: "#fff", marginTop: 10 }}>One Sec...</Text>
      </View>
    );
  }

  return (
    <View
      style={styles.container}
      onLayout={(e) => {
        setWidth(e.nativeEvent.layout.width);
        setHeight(e.nativeEvent.layout.height);
      }}
    >
      <BallTracking
        openZModal={openZModal}
        setOpenZModal={setOpenZModal}
        selectedCells={selectedCells}
        action={currAction}
        setSelectedCells={setSelectedCells}
        onConfirm={(activeCell) => {
          applyZAxisCell(activeCell);
        }}
        onClearZAxis={() => {
          // clear string edge
          if (!currAction || currAction === "X-X-X-X-X-X-X-X-X-X-X-X") return;

          const parts = currAction.split("-"); //split
          while (parts.length < 12) parts.push("X"); // if less add

          parts[10] = "X"; // override
          parts[11] = "X"; // override

          const updated = parts.join("-"); // join the new parts
          setCurrAction(updated);
          props.SetCurrentAction(updated);
        }}
      />
      <ReactModal
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setIsModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(5px)",
          },
          content: {
            backgroundColor: "#fff",
            width: 400,
            height: 150,
            border: "none",
            inset: "auto",
            padding: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.6rem",
          },
        }}
      >
        <Text style={{ fontWeight: "bold", fontSize: 17, textAlign: "center" }}>
          Please provide the GK jersey no in the corresponding fields. Please
          select the proper Half Tag "FHN/SHN" before analysis.
        </Text>
      </ReactModal>

      {openStringFixer && (
        <View
          style={{
            width: "100%",
            height: "100%",
            margin: -5,
            overflow: "auto",
            position: "absolute",
            flexDirection: isLandscape ? "row" : "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#e1e1e1",
            zIndex: 6,
          }}
        >
          <View
            style={{
              flex: 1,
              height: "100%",
              padding: 5,
              width: "90%",
            }}
          >
            <Text
              style={{
                fontFamily: "Poppins",
                fontSize: 10,
                fontWeight: "700",
                color: "#21212e",
              }}
            >
              Error Strings ( Tap to EDIT )
            </Text>
            <FlatList
              data={errorStrings}
              extraData={errorStrings}
              keyExtractor={(item) => item.index.toString()}
              style={{
                backgroundColor: "#e1e1e1",
                elevation: 8,
              }}
              renderItem={({ item }) => {
                const handleDelete = () => {
                  let check = window.confirm(
                    "This will removed the error string. Comfirm ? ",
                  );
                  if (check) {
                    const tempStrs = errorStrings?.filter((i) => {
                      return i.index !== item.index;
                    });
                    const originalStrs = originalForFormating?.filter((i) => {
                      return i.index !== item.index;
                    });
                    setErrorStrings(tempStrs);
                    originalStrs &&
                      FormatString(
                        originalStrs.map((s) => s.str).toString(),
                        handleFormatedString,
                      );
                  }
                };
                const changeStrHandler = (text) => {
                  if (text !== "") {
                    const tempStrs = errorStrings.map((i) => {
                      if (i.index === item.index) {
                        return { index: i.index, str: text };
                      }
                      return i;
                    });
                    setErrorStrings(tempStrs);
                  }
                };

                return (
                  <View
                    style={{
                      widthy: "100%",
                      height: 30,
                      backgroundColor: "#fff",
                      marginVertical: 2,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 2,
                    }}
                  >
                    <TextInput
                      onFocus={() => {
                        setErrorStrOnFocus(item);
                      }}
                      onChangeText={changeStrHandler}
                      style={{ flex: 1 }}
                      value={item.str}
                    />
                    <FaTrash onClick={handleDelete} />
                  </View>
                );
              }}
            />
          </View>
          <View
            style={{
              flex: 0.5,
              height: "100%",
              backgroundColor: "#e1e1e1",
              flexDirection: isLandscape ? "column" : "row",
              justifyContent: "space-evenly",
            }}
          >
            <View>
              {Boolean(stringLastTime) && (
                <View
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 10,
                      color: "#616161",
                    }}
                  >
                    Last Action Time
                  </Text>
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      fontWeight: "700",
                      color: "#131313",
                    }}
                  >
                    {stringLastTime}
                  </Text>
                </View>
              )}
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 5,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "#616161",
                  }}
                >
                  Total
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {originalForFormating?.length}
                </Text>
              </View>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 5,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "tomato",
                  }}
                >
                  Total Error
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {errorStrings?.length || "0"}
                </Text>
              </View>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 5,
                  paddingBottom: 0,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "tomato",
                    textAlign: "center",
                  }}
                >
                  With Timestamp
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {
                    errorStrings?.filter((e) => {
                      let chck = e.str?.split("-");
                      if (chck[6] !== "X") {
                        return true;
                      }
                    })?.length
                  }
                </Text>
              </View>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                disabled={mergingLoading}
                onPress={mergeErrorToOriginal}
                style={{
                  padding: 5,
                  backgroundColor: "#00A2DF",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <FaForward color="#fff" />
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#fff",
                    paddingLeft: 2,
                  }}
                >
                  MERGE
                </Text>
                {mergingLoading && (
                  <View
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#ffffff60",
                      borderRadius: 2,
                      justifyContent: "center",
                      position: "absolute",
                      zIndex: 5,
                      alignItems: "center",
                    }}
                  >
                    <ActivityIndicator />
                  </View>
                )}
              </TouchableOpacity>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                onPress={removeAllErrorFromOriginal}
                style={{
                  padding: 5,
                  borderRadius: 2,
                  borderWidth: 1,
                  backgroundColor: "orange",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 9,
                    fontWeight: "700",
                    color: "#131313",
                    paddingLeft: 2,
                    textAlign: "center",
                  }}
                >
                  DISCARD ALL ERRORS
                </Text>
              </TouchableOpacity>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                onPress={() => setOpenStringFixer(false)}
                style={{
                  padding: 5,
                  borderRadius: 2,
                  borderWidth: 1,
                  borderColor: "tomato",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <FaWindowClose color="#131313" />
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                    paddingLeft: 2,
                  }}
                >
                  CLOSE
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              flex: 1,
              height: "100%",
              padding: 5,
              width: "100%",
            }}
          >
            <Text
              style={{
                fontFamily: "Poppins",
                fontSize: 10,
                fontWeight: "700",
                width: "100%",
                textAlign: "right",
                color: "#21212e",
              }}
            >
              Analysed Strings
            </Text>
            <FlatList
              ref={originalListRef}
              style={{ backgroundColor: "#fff", paddingLeft: 5 }}
              keyExtractor={(item) => item.index.toString()}
              getItemLayout={(data, index) => ({
                length: 12,
                offset: 12 * index,
                index,
              })}
              data={originalForFormating}
              extraData={originalForFormating}
              removeClippedSubviews
              renderItem={({ item }) => {
                return (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor:
                        ErrorStrOnFocus?.index === item.index && "lime",
                    }}
                  >
                    <Text style={{ fontFamily: "Poppins", fontSize: 9 }}>
                      {item.str}
                    </Text>
                  </View>
                );
              }}
            />
          </View>
        </View>
      )}

      {!isLandscape && (
        <View
          style={{
            width: "100%",
            height: "100%",
            margin: -5,
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#111",
            zIndex: 5,
          }}
        >
          <Logo size={18} />
          <Text
            style={{
              color: "#131313",
              fontSize: "1em",
              padding: 10,
              marginTop: 5,
            }}
          >
            ANALYST CONTROLLER
          </Text>

          <View
            style={{
              flexDirection: props.matchString?.[matchId] ? "row" : "column",
              justifyContent: "center",
              alignItems: "center",
              marginVertical: 5,
            }}
          >
            <Text
              style={{
                fontSize: 12,
                color: "#131313",
                backgroundColor: "#e1e1e190",
                padding: 5,
              }}
            >
              ANALYST ID : {props.analystId}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: "#131313",
                backgroundColor: "#e1e1e190",
                padding: 5,
                margin: 2,
              }}
            >
              MATCH ID : {matchId}
            </Text>
          </View>

          {Boolean(props.matchString?.[matchId]) && (
            <View>
              <Text
                style={{
                  color: "#dddddd",
                  textAlign: "center",
                  width: "100%",
                  fontSize: 12,
                }}
              >
                Analysed String
              </Text>
              <TextInput
                editable={false}
                style={{
                  color: "#fff",
                  borderWidth: 1,
                  borderColor: "#e1e1e1",
                  padding: 5,
                }}
                value={props.matchString?.[matchId]}
              />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    marginRight: 5,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "tomato",
                    borderRadius: 2,
                  }}
                  onClick={onClearPress}
                >
                  <FaTrash /> CLEAR STRING
                </button>
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    marginHorizontal: 10,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "green",
                    borderRadius: 2,
                    color: "#fff",
                  }}
                  onClick={onCopyPress}
                >
                  <FaCopy /> COPY STRING
                </button>
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    borderWidth: 0,
                    fontWeight: "700",
                    marginLeft: 5,
                    backgroundColor: "#00bbee",
                    color: "#fff",
                    borderRadius: 2,
                  }}
                  onClick={onSharePress}
                >
                  <FaShare /> SHARE STRING
                </button>
              </View>
              <button
                style={{
                  padding: 10,
                  marginTop: 20,
                  fontSize: width / 50,
                  marginRight: 5,
                  fontWeight: "700",
                  borderWidth: 0,
                  backgroundColor: "#e1e1e1",
                  borderRadius: 2,
                }}
                onClick={onSaveStringPress}
              >
                <FaSave /> <Text>SAVE STRING</Text>
              </button>
            </View>
          )}

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              style={{
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                fontSize: width / 80,
                marginRight: 5,
                fontWeight: "700",
                borderWidth: 0,
                backgroundColor: "#ffa500",
                borderRadius: 2,
              }}
              onClick={onLoadSaveStringPress}
            >
              <FaCloudDownloadAlt /> <Text>LOAD SAVED STRING</Text>
            </button>
            <TouchableOpacity
              style={{
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                fontSize: width / 80,
                marginLeft: 5,
                fontWeight: "700",
                color: "#fff",
                borderWidth: 1,
                borderColor: "lime",
                backgroundColor: "transparent",
                borderRadius: 2,
              }}
              onPress={onPastePress}
            >
              <FaClipboard />{" "}
              <Text style={{ color: "lime" }}>PASTE FROM CLIPBOARD</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              backgroundColor: "#00ced1",
              paddingVertical: 5,
              paddingHorizontal: 30,
              justifyContent: "center",
              alignItems: "center",
              margin: 5,
              borderRadius: "0.2rem",
            }}
          >
            <img
              src={RotateImg}
              alt="rotate_animated_icon"
              style={{ width: 40 }}
            />
            <Text
              style={{
                color: "#131313",

                letterSpacing: 0.5,
                fontSize: width / 25,
                textAlign: "center",
              }}
            >
              Rotate to landscape to continue .
            </Text>
          </View>
        </View>
      )}

      {isLandscape && !isFullScreen && (
        <View
          style={{
            width: "100%",
            height: "100%",
            overflow: "auto",
            position: "absolute",
            backgroundColor: "rgba(255, 255, 255, 1)",
            zIndex: 5,
          }}
        >
          <View
            id="toolbar"
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              width: "100%",
              paddingVertical: "1rem",
              flexDirection: "row",
              alignItems: "center",
              paddingRight: "2rem",
              paddingLeft: "0.5rem",
              boxShadow: "0px 2px 6px #00000020",
            }}
          >
            <IconButton
              onClick={() => {
                history.goBack();
              }}
              size="small"
              sx={{ background: "#e1e1e1", mr: 1 }}
            >
              <ArrowBack fontSize="16px" />
            </IconButton>
            <Text
              style={{
                color: "#1976D2",
                fontSize: "12.5px",
                fontWeight: "600",
              }}
            >
              {matchId}
            </Text>
            <Text
              style={{
                color: "#545D69",
                fontSize: "12.5px",
                fontWeight: "600",
                marginStart: "0.2rem",
              }}
            >
              {teamADetails?.name}
              {" vs "}
              {teamBDetails?.name}
            </Text>
            <Text
              style={{
                color: "#545D69",
                fontSize: "12.5px",
                fontWeight: "400",
                marginLeft: "auto",
                alignItems: "center",
              }}
            >
              {props.analystName}
            </Text>
          </View>

          <View style={{ flexDirection: "row", marginTop: "1rem" }}>
            <View
              id="leftPortion"
              style={{
                marginStart: "1.4rem",
                width: "54%",
              }}
            >
              <Text
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#09101d",
                }}
              >
                Analysis Details
              </Text>

              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "1rem",
                }}
              >
                <View
                  id="card1"
                  style={{
                    flex: "0.49",
                    padding: "1rem",
                    borderRadius: "0.2em",
                    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                    flexDirection: "row",
                  }}
                >
                  <View
                    style={{
                      paddingVertical: "1rem",
                      justifyContent: "center",
                      paddingHorizontal: "1rem",
                      fontFamily: "Source Sans 3",
                      color: "rgba(0, 0, 0, 1)",
                      backgroundColor: "rgba(231, 245, 236, 1)",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "rgba(9, 16, 29, 1)",
                      }}
                    >
                      {props.analystId}
                    </Text>
                  </View>
                  <View
                    style={{
                      flex: "1",
                      flexDirection: "column",
                      marginStart: "1rem",
                      gap: 4,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#000",
                      }}
                    >
                      {props.analystName}
                    </Text>
                    <Text
                      style={{
                        fontSize: "8px",
                        fontWeight: "400",
                        color: "rgba(57, 68, 82, 1)",
                      }}
                    >
                      Analyst ID & Name
                    </Text>
                  </View>
                </View>

                <View
                  id="card2"
                  style={{
                    flex: "0.49",
                    padding: "1rem",
                    borderRadius: "0.2em",
                    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                    flexDirection: "row",
                  }}
                >
                  {matchVideoData && matchDetails && (
                    <View
                      style={{
                        height: "4rem",
                        width: "4rem",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgressbar
                        value={
                          ((matchVideoData?.last_timestamp &&
                            matchDetails?.youtube_videos[0]
                              ?.total_video_duration) ||
                            videoDuration) &&
                          parseInt(
                            (matchVideoData?.last_timestamp /
                              (matchDetails?.youtube_videos[0]
                                ?.total_video_duration || videoDuration)) *
                            100,
                          )
                        }
                        strokeWidth={12}
                        styles={buildStyles({
                          rotation: 0.25,
                          strokeLinecap: "butt",
                          pathTransitionDuration: 0.5,
                          pathColor: "rgba(12, 157, 65, 1)",
                          trailColor: "rgba(217, 217, 217, 1)",
                        })}
                      />
                      <Text
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "rgba(57, 68, 82, 1)",
                          position: "absolute",
                          top: "40%",
                        }}
                      >
                        {((matchVideoData?.last_timestamp &&
                          matchDetails?.youtube_videos[0]
                            ?.total_video_duration) ||
                          videoDuration) &&
                          parseInt(
                            (matchVideoData?.last_timestamp /
                              (matchDetails?.youtube_videos[0]
                                ?.total_video_duration || videoDuration)) *
                            100,
                          )}
                        %
                      </Text>
                    </View>
                  )}
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "column",
                      marginStart: "1rem",
                      gap: 4,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#000",
                      }}
                    >
                      Analysis Progress
                    </Text>
                    <View
                      style={{
                        paddingHorizontal: "0.5rem",
                        paddingVertical: "0.4rem",
                        backgroundColor: "rgba(237, 249, 240, 1)",
                        borderRadius: "0.2rem",
                        maxWidth: "80%",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: "8px",
                          fontWeight: "400",
                          color: "rgba(57, 68, 82, 1)",
                        }}
                      >
                        Time taken till now:{" "}
                        {(matchVideoData?.tat &&
                          (matchVideoData?.tat || "0") + " secs") ||
                          "N/A"}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>

              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "rgba(9, 16, 29, 1)",
                  marginTop: "1rem",
                }}
              >
                Tools
              </Text>

              <View
                style={{
                  marginTop: "0.6rem",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={onLoadSaveStringPress}
                  style={{
                    borderWidth: 0,
                    backgroundColor: "rgba(240, 128, 34, 1)",
                    borderRadius: "0.2rem",
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: "32%",
                    minWidth: "32%",
                    justifyContent: "center",
                    paddingVertical: "0.8rem",
                  }}
                >
                  <View
                    style={{
                      backgroundColor: "rgba(241, 141, 56, 1)",
                      padding: "0.5rem",
                    }}
                  >
                    <FaCloudDownloadAlt color={"#fff"} size={12} />
                  </View>
                  <View style={{ marginStart: "0.4rem", gap: 4 }}>
                    <Text
                      style={{
                        color: "rgba(255, 255, 255, 1)",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Load Auto Saved
                    </Text>
                    <Text style={{ color: "rgba(57, 68, 82, 1)", fontSize: 8 }}>
                      Load auto saved string
                    </Text>
                  </View>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={onCopyPress}
                  style={{
                    borderWidth: 0,
                    backgroundColor: "rgba(240, 128, 34, 1)",
                    borderRadius: "0.2rem",
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: "32%",
                    minWidth: "32%",
                    justifyContent: "center",
                    paddingVertical: "0.8rem",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "rgba(241, 141, 56, 1)",
                      padding: "0.5rem",
                    }}
                  >
                    <FaCopy color={"#fff"} size={12} />
                  </Stack>
                  <View style={{ marginStart: "0.4rem", gap: 4 }}>
                    <Text
                      style={{
                        color: "rgba(255, 255, 255, 1)",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Copy String
                    </Text>
                    <Text style={{ color: "rgba(57, 68, 82, 1)", fontSize: 8 }}>
                      Copy generated string
                    </Text>
                  </View>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={onPastePress}
                  style={{
                    borderWidth: 0,
                    backgroundColor: "rgba(240, 128, 34, 1)",
                    borderRadius: "0.2rem",
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: "32%",
                    minWidth: "32%",
                    justifyContent: "center",
                    paddingVertical: "0.8rem",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "rgba(241, 141, 56, 1)",
                      padding: "0.5rem",
                    }}
                  >
                    <FaPaste color={"#fff"} size={12} />
                  </Stack>
                  <View style={{ marginStart: "0.4rem", gap: 4 }}>
                    <Text
                      style={{
                        color: "rgba(255, 255, 255, 1)",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Paste String
                    </Text>
                    <Text style={{ color: "rgba(57, 68, 82, 1)", fontSize: 8 }}>
                      Paste from clipboard
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>

              <View
                style={{
                  marginTop: "0.4rem",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={onClearPress}
                  style={{
                    borderWidth: 0,
                    backgroundColor: "rgba(240, 128, 34, 1)",
                    borderRadius: "0.2rem",
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: "32%",
                    minWidth: "32%",
                    justifyContent: "center",
                    paddingVertical: "0.8rem",
                  }}
                >
                  <Stack
                    style={{
                      backgroundColor: "rgba(241, 141, 56, 1)",
                      padding: "0.5rem",
                    }}
                  >
                    <FaTrash color={"#fff"} size={12} />
                  </Stack>
                  <View style={{ marginStart: "0.4rem", gap: 4 }}>
                    <Text
                      style={{
                        color: "rgba(255, 255, 255, 1)",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Delete String
                    </Text>
                    <Text style={{ color: "rgba(57, 68, 82, 1)", fontSize: 8 }}>
                      Delete saved string
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>

              <TouchableOpacity
                onPress={() => {
                  getAnalysisStatus();
                }}
                style={{
                  borderWidth: 0,
                  backgroundColor: "rgba(240, 128, 34, 1)",
                  borderRadius: "0.2rem",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingVertical: "0.8rem",
                  marginTop: "1rem",
                }}
              >
                <Text
                  style={{
                    color: "rgba(255, 255, 255, 1)",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {props.matchString?.[matchId]
                    ? "Continue Match Analysis"
                    : "Start Match Analysis"}
                </Text>
                <FaArrowRight
                  style={{ marginLeft: "0.6rem" }}
                  color={"#fff"}
                  size={12}
                />
              </TouchableOpacity>
            </View>

            <View
              id="rightPortion"
              style={{
                backgroundColor: "rgba(255, 255, 255, 1)",
                padding: "1rem",
                borderRadius: "0.2rem",
                boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                width: "40%",
                marginHorizontal: "1rem",
              }}
            >
              <View>
                <Text
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "rgba(9, 16, 29, 1)",
                  }}
                >
                  Match String
                </Text>

                <Text
                  style={{
                    fontSize: "8px",
                    fontWeight: "600",
                    color: "rgba(0, 152, 95, 1)",
                    marginTop: "0.4rem",
                  }}
                >
                  {props.matchString?.[matchId]
                    ? "String Loaded Successfully."
                    : "Paste the match string here."}
                </Text>
                <TouchableOpacity
                  disabled={!props.matchString?.[matchId]}
                  onPress={onSharePress}
                  style={{
                    position: "absolute",
                    right: 0,
                    opacity: props.matchString?.[matchId] ? 1 : 0.5,
                  }}
                >
                  <FaShareAlt />
                </TouchableOpacity>
              </View>

              <FlatList
                // inverted
                // scrollsToTop
                style={{
                  marginVertical: "0.8rem",
                  paddingHorizontal: "0.5rem",
                  maxHeight: "13rem",
                }}
                showsHorizontalScrollIndicator={false}
                // horizontal
                data={props.matchString?.[matchId]
                  ?.split(",")
                  ?.reverse()
                  ?.map((i) => i.toString())}
                renderItem={({ item }) => (
                  <Text style={{ color: "#394452" }}>
                    {item}
                    {/* {", "} */}
                  </Text>
                )}
                keyExtractor={(item, index) => item + index}
              />

              <TouchableOpacity
                disabled={!props.matchString?.[matchId]}
                onPress={onSaveStringPress}
                style={{
                  // marginTop: "2rem",
                  backgroundColor: "rgba(0, 146, 54, 1)",
                  alignSelf: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingVertical: "1rem",
                  paddingHorizontal: "2rem",
                  flexDirection: "row",
                  borderRadius: "3px",
                  opacity: !props.matchString?.[matchId] ? 0.5 : 1,
                }}
              >
                <FaSave color={"#fff"} />
                <Text
                  style={{
                    marginLeft: "0.5rem",
                    color: "rgba(255, 255, 255, 1)",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  SAVE STRING
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          {/* {Boolean(fullstringanalyse) && (
            <View
              style={{
                backgroundColor: "rgba(255, 255, 255, 1)",
                padding: "1rem",
                borderRadius: "0.2rem",
                boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                marginHorizontal: "1.4rem",
                marginVertical: "1rem",
              }}
            >
              <Text
                style={{
                  fontSize: width / 70,
                  fontWeight: "700",
                  color: "#000",
                }}
              >
                FORMATTER & SUBMISSION
              </Text>

              <View
                style={{
                  marginTop: "0.8rem",
                  flexDirection: "row",
                  flex: 1,
                  justifyContent: "space-between",
                }}
              >
                <TouchableOpacity
                  onPress={openFormatterHanlder}
                  style={{
                    flex: 0.3,
                    backgroundColor: "rgba(240, 128, 34, 1)",
                    alignItems: "center",
                    paddingVertical: "0.8rem",
                    borderRadius: "3px",
                  }}
                >
                  {formatProgress && (
                    <ActivityIndicator
                      style={{ position: "absolute", left: 0, right: 0 }}
                    />
                  )}

                  <Text
                    style={{
                      marginLeft: "0.5rem",
                      color: "rgba(255, 255, 255, 1)",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {formatProgress ? "FORMATTING..." : "FORMAT STRING"}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={() => {
                    if (originalForFormating?.length > 0) {
                      gotoSubmitHandler();
                    }
                  }}
                  style={{
                    flex: 0.65,
                    opacity: originalForFormating?.length > 0 ? 1 : 0.5,
                    backgroundColor: "rgba(0, 146, 54, 1)",
                    alignItems: "center",
                    paddingVertical: "0.8rem",
                    flexDirection: "row",
                    borderRadius: "3px",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "rgba(255, 255, 255, 1)",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    Proceed to Deployment
                  </Text>
                  <FaArrowRight
                    color={"#fff"}
                    style={{ marginLeft: "0.5rem" }}
                  />
                </TouchableOpacity>
              </View>

              {Boolean(stringLastTime) && (
                <View
                  style={{
                    marginTop: "1rem",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        color: "#000",
                      }}
                    >
                      First Action Time
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: "#000",
                      }}
                    >
                      {stringStartTime}
                    </Text>
                  </View>
                  <View
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        color: "#000",
                      }}
                    >
                      Last Action Time
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: "#000",
                      }}
                    >
                      {stringLastTime}
                    </Text>
                  </View>
                </View>
              )}
            </View>
          )} */}
        </View>
      )}

      {showBoxAlert ? (
        <BoxPopUp
          text={"Possible Missed Foul"}
          onPress={() => setShowBoxAlert(false)}
        />
      ) : null}

      {showSideChangeAlert && (
        <View
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            backgroundColor: "#ffffff90",
            zIndex: 999,
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              backgroundColor: "#131313",
            }}
          >
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              Are you sure you want to change side?
            </Text>
            <View
              style={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "center",
                backgroundColor: "#131313",
                marginTop: 20,
              }}
            >
              <TouchableOpacity onPress={confirmSideChange}>
                <Text
                  style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}
                >
                  YES
                </Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={cancelSideChange}>
                <Text
                  style={{
                    fontWeight: "700",
                    fontSize: 14,
                    color: "#ffffffaa",
                  }}
                >
                  NO
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}

      {showSideChangeAlert2 && (
        <View
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            backgroundColor: "#ffffff90",
            zIndex: 999,
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              backgroundColor: "#131313",
              width: 400,
            }}
          >
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              Please change the Half tag FHN/SHN as required
            </Text>
            <View
              style={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "center",
                backgroundColor: "#131313",
                marginTop: 20,
              }}
            >
              <TouchableOpacity onPress={() => setShowSideChangeAlert2(false)}>
                <Text
                  style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}
                >
                  OK
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}

      <View
        style={[
          styles.top,
          {
            flexDirection: secondHalf ? "row-reverse" : "row",
            height: "58%",
          },
        ]}
      >
        <View
          style={{
            flex: 1,
            padding: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TeamLayout
            side={secondHalf ? "right" : "left"}
            onPress={playerPress}
            teamAnnotation="A"
            gkJr={teamAGK}
            setGkJr={setTeamAGK}
            teamDetails={teamADetails}
            layoutWidth={width}
            players={teamAPlayersSorted}
            outPlayers={outPlayers?.filter((i) => i?.team === "A")}
            subsPlayers={teamASubsPlayerSorted}
          />
        </View>
        <View style={{ flex: 2, padding: 1 }}>
          <PositionLayedMap onPress={onFieldPress} />
        </View>
        <View
          style={{
            flex: 1,
            padding: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TeamLayout
            side={secondHalf ? "left" : "right"}
            onPress={playerPress}
            teamAnnotation="B"
            gkJr={teamBGK}
            setGkJr={setTeamBGK}
            teamDetails={teamBDetails}
            layoutWidth={width}
            players={teamBPlayersSorted}
            outPlayers={outPlayers?.filter((i) => i?.team === "B")}
            subsPlayers={teamBSubsPlayerSorted}
          />
        </View>
      </View>

      <View
        style={[
          styles.bottom,
          {
            height: "42%",
            flexDirection: "row",
            paddingHorizontal: "0.2rem",
          },
        ]}
      >
        <View
          style={{
            flex: 1,
            paddingHorizontal: "0.5rem",
            ...(showZButton && { marginBottom: "5rem" }),
          }}
        >
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              gap: "0.7rem",
            }}
          >
            <GroupButtons label="PASSING" layoutWidth={width}>
              {proMode ? (
                <EventButton
                  layoutWidth={width}
                  value={"PS"}
                  color="#F5D63D"
                  onPress={onKeyPress}
                  first={true}
                />
              ) : (
                <>
                  <EventButton
                    layoutWidth={width}
                    value={"SP"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"LP"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"C"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                </>
              )}
              <EventButton
                layoutWidth={width}
                value={"TB"}
                color="#F5D63D"
                onPress={onKeyPress}
                last={true}
              />
            </GroupButtons>

            <GroupButtons label="DEFENSE" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"ST"}
                color="#78C5D6"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"SL"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"IN"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"CL"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"PR"}
                color="#78C5D6"
                onPress={onKeyPress}
                last
              />
            </GroupButtons>

            <GroupButtons label="SHOOTING" layoutWidth={width}>
              {proMode ? (
                <EventButton
                  layoutWidth={width}
                  value={"SHT"}
                  color="#F28C33"
                  onPress={onKeyPress}
                  first
                />
              ) : (
                <>
                  <EventButton
                    layoutWidth={width}
                    value={"LS"}
                    color="#F28C33"
                    onPress={onKeyPress}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"CS"}
                    color="#F28C33"
                    onPress={onKeyPress}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                    first
                  />
                </>
              )}
            </GroupButtons>

            <GroupButtons label="PHYSICAL" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"H"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"AD"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"GD"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
            </GroupButtons>

            <GroupButtons label="BALL CONTROL" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"DR"}
                color="#79C267"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"T"}
                color="#79C267"
                onPress={onKeyPress}
                first
              />
            </GroupButtons>
          </View>

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              // justifyContent: "space-between",
              // backgroundColor: "red",
              marginTop: "0.4rem",
              flex: 1,
            }}
          >
            <View id="bottomLeft" style={{ flex: 0.7 }}>
              <View
                style={{
                  flexDirection: "row",
                  gap: "0.7rem",
                }}
              >
                <GroupButtons label="SPECIAL" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"THW"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"OFF"}
                    label={"OF"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"HB"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"DL"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
                <GroupButtons label="GOAL KEEPING" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"GS"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"GH"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"GT"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
                <GroupButtons label="HALF TAG" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={halfTag}
                    color="#FEC5D2"
                    onPress={onHalfTag}
                    first
                  />
                </GroupButtons>
                <GroupButtons label="Subtitution" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"SUB"}
                    color="#717272"
                    onPress={handleSub}
                    textStyle={{ color: "#fff" }}
                    first
                  />
                </GroupButtons>
                {showZButton && (
                  <EventButton
                    layoutWidth={width}
                    value={"Z-Axis"}
                    color="#717272"
                    onPress={() => setOpenZModal(true)}
                    textStyle={{ color: "#fff" }}
                    first
                  />
                )}
                <SubtitionModal
                  open={showSubstitutionModal}
                  onClose={() => setShowSubstitutionModal(false)}
                  teamADetails={teamADetails}
                  teamBDetails={teamBDetails}
                  teamAPlayers={teamAPlayersSorted}
                  teamBPlayers={teamBPlayersSorted}
                  teamAPlayerSubs={teamASubsPlayerSorted}
                  teamBPlayerSubs={teamBSubsPlayerSorted}
                  currentTime={videoTimeFromServer?.current}
                  onUpdate={onSubtituteUpdate}
                />
              </View>

              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "0.7rem",
                  marginTop: "0.4rem",
                  flexWrap: "wrap",
                }}
              >
                {showZButton && (
                  <GroupButtons label="GOAL POST" layoutWidth={width}>
                    <EventButton
                      layoutWidth={width}
                      value={"Z"}
                      color="#717272"
                      onPress={() => setOpenZModal(true)}
                      textStyle={{ color: "#fff" }}
                      first
                    />
                  </GroupButtons>
                )}
                <GroupButtons label="FOOT TOGGLE" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"L"}
                    color="#717171"
                    onPress={onKeyPress}
                    textStyle={{ color: "#fff" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                    }}
                  />

                  <EventButton
                    layoutWidth={width}
                    value={"R"}
                    color="#717171"
                    onPress={onKeyPress}
                    textStyle={{ color: "#fff" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                    }}
                  />
                </GroupButtons>

                <GroupButtons label="NOTATION" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"0"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 80,
                      paddingRight: width / 80,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"1"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 80,
                      paddingRight: width / 80,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"2"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 80,
                      paddingRight: width / 80,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"3"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 80,
                      paddingRight: width / 80,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"4"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 80,
                      paddingRight: width / 80,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                </GroupButtons>

                <GroupButtons label="BALL CONTROL" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"PC"}
                    color="#C6C6C6"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
                <GroupButtons label="Miscounduct" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"MC"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                </GroupButtons>
                <GroupButtons label="DROPBALL" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"DRP"}
                    color="#f28c33"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
              </View>

              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "0.7rem",
                  marginTop: "0.4rem",
                }}
              >
                <GroupButtons label="SPECIAL EVENTS" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"CN"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"FK"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"PK"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"F"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"GK"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"OG"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"G"}
                    color="#76BFF9"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"YC"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"RC"}
                    color="#F65E5E"
                    onPress={onKeyPress}
                  />
                </GroupButtons>
                <GroupButtons label="Breaks" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"OUT"}
                    color="#0e9f6e"
                    textStyle={{ color: "#fff" }}
                    onPress={onKeyPress}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"STP"}
                    color="#FF0000"
                    textStyle={{ color: "#fff" }}
                    onPress={onKeyPress}
                  />
                </GroupButtons>
              </View>
            </View>

            <View
              id="bottomRight"
              style={{
                // paddingRight: "1rem",
                flex: 0.3,
              }}
            >
              <View
                id="actions"
                style={{
                  // flex: 1,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  position: "relative",
                }}
              >
                {/* {fetchingTime && (
                  <View
                    style={{
                      zIndex: 10,
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#e1e1e190",
                    }}
                  >
                    <ActivityIndicator size="small" />
                  </View>
                )} */}
                <View style={{ flex: 0.49, zIndex: 1 }}>
                  <View
                    style={{
                      backgroundColor: "rgba(237, 249, 240, 1)",
                      borderRadius: "0.2rem",
                      paddingVertical: "0.3rem",
                    }}
                  >
                    <Text
                      style={{
                        color: "rgba(40, 125, 60, 1)",
                        paddingStart: "0.5rem",
                        fontSize: "7px",
                        fontFamily: "400",
                      }}
                    >
                      This is the current action
                    </Text>
                  </View>

                  <View
                    style={{
                      marginTop: "0.4rem",
                      backgroundColor: "rgba(237, 249, 240, 1)",
                      borderColor: "rgba(40, 125, 60, 1)",
                      borderRadius: "0.2rem",
                      borderWidth: 1,
                      paddingVertical: "0.4rem",
                      maxheight: "3.5rem",
                    }}
                  >
                    <Text
                      style={{
                        color: "rgba(9, 16, 29, 1)",
                        paddingStart: "0.5rem",
                        fontSize: "9px",
                        fontFamily: "700",
                      }}
                    >
                      {currAction}
                    </Text>
                  </View>
                </View>

                <View style={{ flex: 0.49, zIndex: 1 }}>
                  <View
                    style={{
                      backgroundColor: "rgba(238, 242, 250, 1)",
                      borderRadius: "0.2rem",
                      paddingVertical: "0.3rem",
                    }}
                  >
                    <Text
                      style={{
                        color: "rgba(46, 90, 172, 1)",
                        paddingStart: "0.5rem",
                        fontSize: "7px",
                        fontFamily: "400",
                      }}
                    >
                      This is the receiver action.
                    </Text>
                  </View>

                  <View
                    style={{
                      marginTop: "0.4rem",
                      backgroundColor: "rgba(238, 242, 250, 1)",
                      borderColor: "rgba(46, 90, 172, 1)",
                      borderRadius: "0.2rem",
                      borderWidth: 1,
                      paddingVertical: "0.4rem",
                      maxheight: "3.5rem",
                    }}
                  >
                    <Text
                      style={{
                        color: "rgba(9, 16, 29, 1)",

                        paddingStart: "0.5rem",
                        fontSize: "9px",
                        fontFamily: "700",
                      }}
                    >
                      {secondAction}
                    </Text>
                  </View>
                </View>
              </View>

              <View id="string">
                <View
                  style={{
                    backgroundColor: "rgba(244, 246, 249, 0.5)",
                    borderRadius: "0.2rem",
                    paddingVertical: "0.3rem",
                  }}
                >
                  <Text
                    style={{
                      color: "rgba(125, 125, 126, 1)",
                      paddingStart: "0.5rem",
                      fontSize: "7px",
                      fontFamily: "400",
                    }}
                  >
                    Analysis String
                  </Text>
                </View>

                <View style={{ flex: 1, marginTop: "0.2rem" }}>
                  <FlatList
                    // inverted
                    // scrollsToTop
                    style={{
                      backgroundColor: "rgba(244, 246, 249, 1)",
                      padding: "0.5rem",
                      maxHeight: "3rem",
                      // flex: 1,
                    }}
                    // showsHorizontalScrollIndicator={false}
                    // horizontal
                    data={fullstringanalyse
                      ?.split(",")
                      ?.reverse()
                      ?.map((i) => i.toString())}
                    renderItem={({ item }) => (
                      <Text style={{ color: "#131313", fontSize: "10px" }}>
                        {item}
                        {", "}
                      </Text>
                    )}
                    keyExtractor={(item, index) => item + index}
                  />
                </View>
              </View>
            </View>
          </View>
        </View>

        <View style={{ gap: "0.5rem" }}>
          <EventButton
            layoutWidth={width}
            value={"SIDE CHANGE"}
            color="rgba(25, 118, 210, 1)"
            onPress={handleSideChange}
            first
            containerStyle={{
              paddingVertical: "0.6rem",
              paddingHorizontal: "0.7rem",
            }}
            textStyle={{ color: "#fff", fontSize: "8px", fontWeight: "600" }}
          />
          <EventButton
            layoutWidth={width}
            value={"BACK SPACE"}
            label={"Backspace"}
            color="rgba(125, 125, 126, 1)"
            onPress={onKeyPress}
            first
            containerStyle={{
              paddingVertical: "0.6rem",
              paddingHorizontal: "0.7rem",
            }}
            textStyle={{ color: "#fff", fontSize: "8px", fontWeight: "600" }}
          />
          <EventButton
            layoutWidth={width}
            value={"NEXT"}
            color="rgba(240, 128, 34, 1)"
            onPress={onNextPress}
            first
            containerStyle={{
              paddingVertical: "0.6rem",
              paddingHorizontal: "0.7rem",
            }}
            textStyle={{ color: "#fff", fontSize: "8px", fontWeight: "600" }}
          />
          <EventButton
            layoutWidth={width}
            value={"DONE"}
            color="rgba(0, 146, 54, 1)"
            onPress={onDonePress}
            first
            containerStyle={{
              paddingVertical: "0.6rem",
              paddingHorizontal: "0.7rem",
            }}
            textStyle={{ color: "#fff", fontSize: "8px", fontWeight: "600" }}
          />
        </View>
      </View>
    </View>
  );
};

const GroupButtons = ({ children, label, layoutWidth, vertical, wrapped }) => {
  return (
    <View
      style={{
        flexDirection: vertical && "row",
        borderWidth: wrapped && 1,
        borderStyle: "dashed",
        padding: wrapped && 5,
      }}
    >
      {wrapped && (
        <View
          style={{
            position: "absolute",
            bottom: -8,
            left: 0,
            right: 0,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontSize: layoutWidth / 200,
              color: "#131313",
              opacity: 0.7,
              fontWeight: "700",
              letterSpacing: 0.25,
            }}
          >
            {label}
          </Text>
        </View>
      )}

      <View
        style={{
          width: !vertical && "100%",
          flexDirection: "row",
          justifyContent: wrapped ? "flex-start" : "space-between",
          alignItems: "center",
          flexWrap: wrapped && "wrap",
        }}
      >
        {children}
      </View>

      {!wrapped && (
        <View
          style={{
            width: !vertical && "100%",
            height: vertical && "100%",
            paddingTop: 5,
            flexDirection: vertical ? "column" : "row",
          }}
        >
          {vertical ? (
            <View
              style={{
                width: "10%",
                flex: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderStyle: "dashed",
              }}
            />
          ) : (
            <View
              style={{
                flex: 1,
                borderLeftWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          )}
          <Text
            style={{
              fontSize: layoutWidth / 200,
              color: "#131313",
              opacity: 0.7,
              fontWeight: "700",
              letterSpacing: 0.25,
            }}
          >
            {label}
          </Text>
          {vertical ? (
            <View
              style={{
                flex: 1,
                width: "10%",
                borderRightWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          ) : (
            <View
              style={{
                flex: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          )}
        </View>
      )}
    </View>
  );
};

const EventButton = ({
  value,
  onPress,
  color = "#131313",
  layoutWidth = 1,
  textStyle,
  containerStyle,
  label,
  disabled,
}) => {
  return (
    <TouchableOpacity
      disabled={disabled}
      onPress={() => onPress(value)}
      style={{
        justifyContent: "center",
        alignItems: "center",
        paddingVertical: layoutWidth / 140,
        paddingHorizontal: layoutWidth / 80,
        backgroundColor: color,
        marginHorizontal: 5,
        borderRadius: 2,
        outline: "none",
        boxShadow: "0pc 1px 3px #13131340",
        ...containerStyle,
        opacity: disabled ? 0.3 : 1,
      }}
    >
      <Text
        style={{
          fontWeight: "700",
          fontSize: layoutWidth / 80,
          ...textStyle,
        }}
      >
        {label ? label : value}
      </Text>
    </TouchableOpacity>
  );
};

const BoxPopUp = ({ text, onPress }) => {
  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        backgroundColor: "#ffffff90",
        zIndex: 999,
      }}
    >
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
          backgroundColor: "#131313",
        }}
      >
        <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
          {text}
        </Text>
        <View
          style={{
            width: "80%",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
            backgroundColor: "#131313",
            marginTop: 20,
          }}
        >
          <TouchableOpacity onPress={onPress}>
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              OK
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const TeamLayout = ({
  layoutWidth,
  teamDetails,
  teamName,
  side,
  teamAnnotation,
  players = [],
  onPress,
  onFocus,
  gkJr,
  setGkJr,
  outPlayers,
  subsPlayers,
}) => {
  return (
    <View
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F9F9F9",
      }}
    >
      <FlatList
        style={{ maxHeight: "50vh", marginVertical: "0.5rem" }}
        ListHeaderComponentStyle={{
          padding: "0.5rem",
        }}
        ListHeaderComponent={
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: layoutWidth / 100,
                fontWeight: "700",
                color:
                  teamAnnotation === "A"
                    ? "rgba(25, 118, 210, 1)"
                    : "rgba(232, 108, 0, 1)",
              }}
            >
              TEAM {teamAnnotation}
            </Text>
            <Text
              style={{
                fontSize: layoutWidth / 100,
                fontWeight: "700",
                color: "rgba(0, 0, 0, 1)",
              }}
            >
              {teamDetails && teamDetails.name}
            </Text>
          </View>
        }
        numColumns={4}
        data={players}
        extraData={players}
        ListFooterComponent={
          <View
            style={{
              width: "100%",
              alignItems: "center",
              marginTop: "0.4rem",
            }}
          >
            <FlatList
              scrollEnabled={false}
              ListHeaderComponentStyle={{
                padding: "0.5rem",
                paddingTop: 0,
                paddingBottom: "0.1rem",
              }}
              ListHeaderComponent={
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: layoutWidth / 100,
                      fontWeight: "700",
                      color:
                        teamAnnotation === "A"
                          ? "rgba(25, 118, 210, 1)"
                          : "rgba(232, 108, 0, 1)",
                    }}
                  >
                    TEAM {teamAnnotation} Subs
                  </Text>
                </View>
              }
              numColumns={4}
              data={subsPlayers}
              extraData={subsPlayers}
              renderItem={({ item }) => {
                const isDisabled = outPlayers
                  ?.map((i) => String(i.jr))
                  ?.includes(item);
                return (
                  <TouchableOpacity
                    disabled={isDisabled}
                    onPress={(e) => {
                      if (isDisabled) {
                        return;
                      }
                      onPress(item, teamAnnotation);
                    }}
                    style={{
                      width: layoutWidth / 25,
                      height: layoutWidth / 25,
                      borderRadius: 5,
                      margin: "0.2rem",
                      backgroundColor:
                        teamAnnotation === "A"
                          ? "rgba(25, 118, 210, 1)"
                          : "rgba(232, 108, 0, 1)",
                      boxShadow: "0px 1px 6px #13131370",
                      justifyContent: "center",
                      alignItems: "center",
                      outline: "none",
                      opacity: isDisabled ? 0.6 : 1,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: layoutWidth / 85,
                        fontWeight: "700",
                        color: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      {item}
                    </Text>
                  </TouchableOpacity>
                );
              }}
              keyExtractor={(item) => item.toString()}
            />
            <Text style={{ fontSize: "8px", fontWeight: "700" }}>
              GOAL KEEPER
            </Text>
            <TextInput
              placeholder="Jr No"
              placeholderTextColor="rgba(255, 255, 255, 1)"
              value={gkJr}
              onChangeText={setGkJr}
              style={{
                width: layoutWidth / 25,
                height: layoutWidth / 25,
                borderRadius: 5,
                backgroundColor:
                  teamAnnotation === "A"
                    ? "rgba(25, 118, 210, 1)"
                    : "rgba(232, 108, 0, 1)",
                color: "rgba(255, 255, 255, 1)",
                boxShadow: "0px 1px 6px #13131370",
                outline: "none",
                textAlign: "center",
                fontSize: layoutWidth / 85,
                fontWeight: "700",
                marginVertical: "0.5rem",
              }}
            />
          </View>
        }
        renderItem={({ item }) => {
          const isDisabled = outPlayers
            ?.map((i) => String(i.jr))
            ?.includes(item);
          return (
            <TouchableOpacity
              disabled={isDisabled}
              onPress={(e) => {
                if (isDisabled) {
                  return;
                }
                onPress(item, teamAnnotation);
              }}
              style={{
                width: layoutWidth / 25,
                height: layoutWidth / 25,
                borderRadius: 5,
                margin: "0.2rem",
                backgroundColor:
                  teamAnnotation === "A"
                    ? "rgba(25, 118, 210, 1)"
                    : "rgba(232, 108, 0, 1)",
                boxShadow: "0px 1px 6px #13131370",
                justifyContent: "center",
                alignItems: "center",
                outline: "none",
                opacity: isDisabled ? 0.6 : 1,
              }}
            >
              <Text
                style={{
                  fontSize: layoutWidth / 85,
                  fontWeight: "700",
                  color: "rgba(255, 255, 255, 1)",
                }}
              >
                {item}
              </Text>
            </TouchableOpacity>
          );
        }}
        keyExtractor={(item) => item.toString()}
      />
    </View>
  );
};

const mapStateToProps = (state) => {
  return {
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    videoControl: state.control.videoControl,
    matchString: state.control.analysedString,
    controllerWindowState: state.control.controllerWindowState,
    analystId: state.auth.analyst_id,
    token: state.auth.token,
    analystName: state.auth.analystName,
  };
};

export default connect(mapStateToProps, {
  SetCurrentAction,
  SetFullAnalyseString,
  AddToActionLog,
  ClearActionLog,
  ClearCurrentAction,
  ClearFullAnalyseString,
  SetVideoControl,
  PushMatchStringToServer,
  FetchMatchStringFromServer,
})(InputBoardNewEvents);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
    // padding: 5,
    overflow: "hidden",
  },
  top: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  bottom: {
    width: "100%",
  },
});
